import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { toast } from "react-toastify";
import CustomAlert from "../../component/AlertComponent/Alert";
import {
  getNumericCellError,
  isNumericComponentType
} from "../../component/InputTableDefault/utilities/numericValidation";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DataGridPro, GridToolbar, GridOverlay } from "@mui/x-data-grid-pro";
import { createColumnRenderers } from "../../component/InputTableDefault/utilities/columnRenderers";
import { baseURL } from "../../api";
import { Global_Data } from "../../globalData/GlobalData";
import { buildColumns } from "../../component/InputTableDefault/utilities/buildColumns";
import {
  hasUnresolvedPlaceholders,
  replaceBracketPlaceholders
} from "../../component/InputTableDefault/utilities/replaceBracketPlaceholder";
import { formatWithTwoDecimals, mapDataForMappingDetails } from "../../component/InputTableDefault/utilities/helper";
import PriceOption from "../../component/InputTableDefault/components/PriceOption";
import TaxOption from "../../component/InputTableDefault/components/TaxOption";
import CurrencyOption from "../../component/InputTableDefault/components/CurrencyOption";
import ActionsMenu from "../../component/InputTableDefault/components/ActionsMenu";
import SelectAllTransferList from "./Transfer/TransferList";
import AddRowButton from "../../component/InputTableDefault/components/AddRowButton";
import SummaryNumber from "../../component/InputTableDefault/summary/SummaryNumber";
import { useSelector } from "react-redux";
import usePendingRequests from "../../component/Loading/usePendingRequests";
import { isDefaultTableEditHydrated } from "../../component/InputTableDefault/utilities/editHydration";
import { createLatestRequestController } from "../../component/InputTableDefault/utilities/latestRequest";
import {
  buildUnitConversionPatch,
  createRowRequestOwnership,
  reconcileUnitConversionRows,
} from "../../component/InputTableDefault/utilities/unitConversionState";

// function useTrackedState(initialState) {
//   const [state, setState] = useState(initialState);

//   const trackedSetState = (newValue) => {
//     console.trace("State updated:", newValue);
//     setState(newValue);
//   };

//   return [state, trackedSetState];
// }

const InputTableDefault = ({
  data,
  tabledata,
  setdefaultTableNameAndModel,
  defaultTableEditData,
  freeFormTabbleEditMainrecord,
  formAction,
  documentSelectTableData,
  documentSelectmappingData: documentSelectmappingDataProp,
  documentSelectMainRecordData,
  documentSelectMainRecordObject,
  eventSelectTableData,
  eventSelectTableMapping,
  formData: formDataProp,
  setdefaultTableValidateFunction,
  isEditRecordHydrated,
  onHydrationStateChange,
}) => {
  const documentSelectmappingData = useMemo(() => {
    if (documentSelectmappingDataProp && Object.keys(documentSelectmappingDataProp).length > 0) {
      return documentSelectmappingDataProp;
    }
    function findMapping(components) {
      if (!components) return null;
      for (const comp of components) {
        if (comp?.component?.sType === "DOCUMENTSELECT") {
          const mapping = comp?.data?.mapping?.tablerecord?.[0]?.mapping;
          if (mapping) {
            const obj = {};
            for (const element of mapping) {
              obj[element.destinationColumn] = element.sourceXPath.split(".")[1];
            }
            return obj;
          }
        }
        const found = findMapping(comp?.child) || findMapping(comp?.details);
        if (found) return found;
      }
      return null;
    }
    return findMapping(formDataProp?.details) || {};
  }, [documentSelectmappingDataProp, formDataProp]);

  const { 
    token, 
    textValue, 
    setdefaultTableSummaryFeild,
    setConversionNamesMapping,
    setDefaultTableSummaryData,
    defaultTableSelectedLocation
  } = Global_Data();
  const [rows, setRows] = useState([]);
  const [colItemOptions, setColItemOptions] = useState([]);
  const [colTaxOptions, setColTaxOptions] = useState([]);
  const [colAccountOptions, setColAccountOptions] = useState([]);
  const [quantitySelectOptions, setQuantitySelectOptions] = useState([]);
  const [priceOptions, setPriceOptions] = useState([]);
  const [priceSelect, setPriceSelect] = useState("");
  const hasUserSelectedPriceOption = useRef(false);
  const [disabledPriceOptionRate, setDisabledPriceOptionRate] = useState([]);
  const [selectedTax, setSelectedTax] = useState("");
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [summaryCalculations, setSummaryCalculations] = useState({});
  const [summaryExtras, setSummaryExtras] = useState([]);
  const [currencyConversion, setCurrencyConversion] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [allFieldNames, setAllFieldNames] = useState({});
  const [tableColOptions, setTableColOptions] = useState({});
  const [dataAware, setDataAware] = useState([]);
  const [sInventory, setSInventory] = useState('');
  const [bulkLoadOpen, setBulkLoadOpen] = useState(false);
  const [bulkActionType, setBulkActionType] = useState("");
  const [BulkLoadData, setBulkLoadData] = useState([]);
  const [rowErrors, setRowErrors] = useState({});
  const [withholdingCode, setWithholdingCode] = useState("");
  const [withholdingValue, setWithholdingValue] = useState("0.00");
  const [withholdingSelect, setWithholdingSelect] = useState("%");
  const [withholdingOptions, setWithholdingOptions] = useState([]);
  const [summaryErrors, setSummaryErrors] = useState({});
  const [baseOptionsLoaded, setBaseOptionsLoaded] = useState(false);
  const pricingRequestSequenceRef = useRef(0);
  const cascadeRequestControllerRef = useRef(null);
  const quantityRequestOwnershipRef = useRef(null);

  if (!cascadeRequestControllerRef.current) {
    cascadeRequestControllerRef.current = createLatestRequestController();
  }
  if (!quantityRequestOwnershipRef.current) {
    quantityRequestOwnershipRef.current = createRowRequestOwnership();
  }
  const {
    loading: requestLoading,
    trackRequest,
  } = usePendingRequests();

  // Refs to prevent re-fetching quantity options when useEffects re-fire
  const editDataQtyFetchedRef = useRef(false);
  const docSelectQtyFetchedRef = useRef(false);

  const inventoryCodeItem = useSelector(state => state.varValue.inventoryCodeItem);

  const columnRenderers = useMemo(
    () => createColumnRenderers({ rows, rowErrors }),
    [rows, rowErrors],
  );

const renderSummaryInputType = (summaryItem) => {
  const inputType = summaryItem?.inputType;
  const component = inputType?.component;
  const idPrefix = `${data?.component?.sName}-${summaryItem?.sSummaryID}`;

  if (!component || component?.sType !== "DISCOUNT") return null;

  return columnRenderers.col_disc({
    params: {
      row: {
        id: summaryItem?.sSummaryID,
        col_disc: withholdingValue,
        col_disc_select: withholdingSelect,
      },
      field: "col_disc",
      value: withholdingValue,
    },
    item: {
      ...summaryItem,
      sColumnID: "col_disc",
      inputType,
      inputId: `${idPrefix}-value`,
      selectId: `${idPrefix}-type`,
    },
    handleRowUpdate: async ({ fieldName, value }) => {
      if (fieldName === "col_disc") {
        setWithholdingValue(value);
      }

      if (fieldName === "col_disc_select") {
        setWithholdingSelect(value);
      }

      setRows(prev => runCalculations({ passedRows: prev }));
    },
    formAction,
    documentSelectTableData,
  });
};

  const fetchColTaxOptions = async () => trackRequest(async () => {
    const colItemIndex = data?.fixcolumns?.findIndex(
      (itemData) => itemData.sColumnID === "col_tax",
    );

    if (colItemIndex === -1) return;

    try {
      const response = await fetch(
        `${baseURL}${data?.fixcolumns?.[colItemIndex]?.inputType?.data?.sDataSource}`,
        {
          method: "GET",
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const result = await response.json();
      const newRecords = result?.data?.records || [];
      // Only update state if records actually changed to prevent re-render loops
      setColTaxOptions(prev => {
        if (JSON.stringify(prev) === JSON.stringify(newRecords)) return prev;
        return newRecords;
      });
      return newRecords;
    } catch (error) {
      console.error("Error fetching column tax options:", error);
      return [];
    }
  });

  const fetchColAccountOptions = async () => trackRequest(async () => {
    const colItemIndex = data?.fixcolumns?.findIndex(
      (itemData) => itemData.sColumnID === "col_account",
    );

    if (colItemIndex === -1) return;

    try {
      const url = data?.fixcolumns?.[colItemIndex]?.inputType?.data?.sDataSource;
      const fullUrl = url?.startsWith("/") ? `${baseURL}${url}` : `${baseURL}/${url}`;
      const response = await fetch(
        fullUrl,
        {
          method: "GET",
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const result = await response.json();
      console.log("#COL_ACCOUNT_FETCH_URL", fullUrl);
      console.log("#COL_ACCOUNT_FETCH_RESULT", result);
      const newRecords = result?.data?.records || result?.data || [];
      console.log("#COL_ACCOUNT_OPTIONS", newRecords);
      setColAccountOptions(prev => {
        if (JSON.stringify(prev) === JSON.stringify(newRecords)) return prev;
        return newRecords;
      });
    } catch (error) {
      console.error("Error fetching column account options:", error);
    }
  });

  const fetchColItemOptions = async () => trackRequest(async () => {
    const colItemIndex = data?.fixcolumns?.findIndex(
      (itemData) => itemData.sColumnID === "col_item",
    );

    if (colItemIndex === -1) return [];

    try {
      const response = await fetch(
        `${baseURL}${data?.fixcolumns?.[colItemIndex]?.inputType?.data?.sDataSource}`,
        {
          method: "GET",
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const result = await response.json();
      const newRecords = result?.data?.records || [];
      // Only update state if records actually changed to prevent re-render loops
      setColItemOptions(prev => {
        if (JSON.stringify(prev) === JSON.stringify(newRecords)) return prev;
        return newRecords;
      });
      return newRecords;
    } catch (error) {
      console.error("Error fetching column item options:", error);
      return [];
    }
  });

  const buildFieldNameMappings = () => {
    if (data?.component?.options?.mode === "DEFAULT") {
      const child = data.child ?? [];
      const fixcolumns = data.fixcolumns ?? [];

      const newMappings = {};
      for (let i = 0; i < child.length; i++) {
        const item = child[i];
        const key = item?.inputtable?.sColumnID;
        const value = item?.component?.sName;
        if (key != null && value != null) newMappings[key] = value;
      }
      for (let i = 0; i < fixcolumns.length; i++) {
        const item = fixcolumns[i];
        const key = item?.sColumnID;
        const value = item?.inputType?.component?.sName;
        if (key != null && value != null) newMappings[key] = value;
      }
      setAllFieldNames(prev => (Object.keys(prev).length ? { ...prev, ...newMappings } : newMappings));
    }
  };

  // Check if this is a payment table (has col_rate with bPayload=1 but no col_qty)
  const isPaymentTable = useMemo(() => {
    return data?.fixcolumns?.some(
      (col) => String(col?.bVisible) === "true" && col?.sColumnID === "col_rate" && Number(col?.inputType?.data?.bPayload) === 1
    ) && !data?.fixcolumns?.some((col) => col?.sColumnID === "col_qty");
  }, [data?.fixcolumns]);

  useEffect(() => {
    let active = true;
    buildFieldNameMappings();

    // Check if table has sDataAware dependency (bCascade tables or payment tables)
    const hasSDataAware = data?.data?.sDataAware;

    // Only add initial row if table doesn't depend on external data selection
    // Payment tables, bCascade tables, and tables with sDataAware should start empty
    if (rows?.length === 0 && !data?.data?.bCascade && !hasSDataAware && !isPaymentTable) {
      handleAddRow();
    }

    setBaseOptionsLoaded(false);
    Promise.all([
      fetchColItemOptions(),
      fetchColTaxOptions(),
      fetchColAccountOptions(),
    ]).finally(() => {
      if (active) setBaseOptionsLoaded(true);
    });

    if (data?.component?.taxcalculation?.sDefaultValue) {
      setSelectedTax(data.component.taxcalculation.sDefaultValue);
    }

    const colQtyIndex = data?.fixcolumns?.findIndex((colItem) => colItem?.sColumnID == "col_qty");
    if(colQtyIndex != -1){
      const qtyData = data?.fixcolumns?.[colQtyIndex];
      setConversionNamesMapping((prev) => {
        if(!prev.hasOwnProperty(qtyData?.inputType?.component.sName)){
          return {...prev, [qtyData?.inputType?.component.sName]: qtyData?.inputType?.component.sConversionName}
        }
        return prev;
      })
    }
    // Also register Expected Qty conversion mapping from child columns
    const expectedQtyChild = data?.child?.find((childItem) => childItem?.component?.sConversionName);
    if (expectedQtyChild) {
      setConversionNamesMapping((prev) => {
        const sName = expectedQtyChild?.component?.sName;
        const sConvName = expectedQtyChild?.component?.sConversionName;
        if (sName && sConvName && !prev.hasOwnProperty(sName)) {
          return { ...prev, [sName]: sConvName };
        }
        return prev;
      });
    }
    return () => {
      active = false;
    };
  }, [data, isPaymentTable]);

  const replaceDataAwarePlaceholders = (source = "", values = {}) => {
    return source.replace(/\{([^}]+)\}/g, (_, key) => {
      return values?.[key] ?? "";
    });
  };
  // Handle tables with sDataAware: show "No records" when sDataAware field is not selected
  const sDataAwareField = data?.data?.sDataAware?.replace(/[{}]/g, "");
  const sDataAwareValue = sDataAwareField ? textValue?.[sDataAwareField] : undefined;
  const cascadeDataSource = data?.data?.sDataSource || "";
  const resolvedCascadeSource = replaceDataAwarePlaceholders(
    cascadeDataSource,
    textValue,
  );
  const persistedDefaultTable = useMemo(() => {
    if (!Array.isArray(defaultTableEditData)) return null;

    return defaultTableEditData.find(record =>
      record?.sInputTableName === data?.component?.sName &&
      String(record?.sInputTableMode || "").toUpperCase() === "DEFAULT"
    ) || null;
  }, [defaultTableEditData, data?.component?.sName]);

  useEffect(() => {
    if (sDataAwareField && !sDataAwareValue) {
      setIsLoading(false);
      setRows([]);
    }
  }, [sDataAwareField, sDataAwareValue]);


  function parseWithholdingSummary(summaryRecord) {
    if (!summaryRecord) {
      return {
        code: "",
        value: "0.00",
        select: "%"
      };
    }

    const inputValue = String(
      summaryRecord?.sInputValue || ""
    ).trim();

    const separatorIndex =
      inputValue.indexOf(":");

    const code =
      separatorIndex >= 0
        ? inputValue
            .slice(0, separatorIndex)
            .trim()
        : inputValue;

    const rawValue =
      separatorIndex >= 0
        ? inputValue
            .slice(separatorIndex + 1)
            .trim()
        : "";

    const select =
      rawValue.includes("%")
        ? "%"
        : "Fix";

    const numericValue = rawValue
      .replace("%", "")
      .replace("Fix", "")
      .replaceAll(",", "")
      .trim();

    return {
      code,
      value: formatWithTwoDecimals(
        Number(numericValue || 0)
      ),
      select
    };
  }

  function parseFreeFormMainrecordDetails(detailsString) {
    const result = {};

    if (!detailsString) {
      return result;
    }

    String(detailsString)
      .split(";")
      .forEach(pair => {
        if (!pair) return;

        const separatorIndex = pair.indexOf(":");

        if (separatorIndex === -1) {
          result[pair.trim()] = null;
          return;
        }

        const key = pair.slice(0, separatorIndex).trim();
        const value = pair.slice(separatorIndex + 1).trim();

        result[key] = value || null;
      });

    return result;
  }

  useEffect(() => {
    if(!documentSelectTableData || documentSelectTableData?.length == 0){
      return;
    }
    const withholdingSummary = documentSelectTableData?.[0]
      ?.tablesummary
      ?.find(
        item =>
          item?.sSummaryID ===
          "summ_withholding"
      );
    const loadedWithholding =
      parseWithholdingSummary(
        withholdingSummary
      );

    setWithholdingCode(
      loadedWithholding.code
    );
    setWithholdingValue(
      loadedWithholding.value
    );
    setWithholdingSelect(
      loadedWithholding.select
    );

    const shouldFetchQty = !docSelectQtyFetchedRef.current;
    docSelectQtyFetchedRef.current = true;
    (async () => {
      const fetchedTaxOptions = await fetchColTaxOptions();
      await fetchColAccountOptions();
      const fetchedItemOptions = await fetchColItemOptions();
      const mainRecordDetails = parseFreeFormMainrecordDetails(documentSelectMainRecordData);
      const loadedTaxCalculation = mainRecordDetails?.taxcalculation;
      if(mainRecordDetails){
        setPriceSelect(mainRecordDetails?.priceoption);
        setSelectedTax(loadedTaxCalculation);
        setSelectedCurrency(documentSelectMainRecordObject?.sCurrency);
      }
      const loadFromRows = [];
      const colItemIndex = data?.fixcolumns?.findIndex(
        (col) => col.sColumnID == "col_item",
      );
      // Use freshly fetched item options, fallback to state
      const itemOptionsForMapping = fetchedItemOptions?.length > 0 ? fetchedItemOptions : colItemOptions;
      documentSelectTableData?.[0]?.tabledetails?.forEach((editItem, index) => {
        const editDataItem = { id: index + 1 };
        data?.fixcolumns?.forEach(async (colItem) => {
          // Check if this fixcolumn's source field is mapped to a DIFFERENT column
          const sourceFieldName = colItem?.inputType?.component?.sName;
          const isValueMappedElsewhere = documentSelectmappingData && sourceFieldName &&
            Object.entries(documentSelectmappingData).some(
              ([destCol, srcField]) => srcField === sourceFieldName && destCol !== colItem?.sColumnID
            );

          if (colItem?.sColumnID === "col_qty") {
            const unitParts = editItem["sUnitConversion"]?.split(":") || [];
            const unitCode = unitParts[0] || "";
            const conversionValue = unitParts[1] ? Number(unitParts[1]) : 0;

            editDataItem["col_qty_select"] = unitCode;
            editDataItem["sUnitConversion"] = `${unitCode}:${formatWithTwoDecimals(conversionValue)}`;
            // Only map value if it's not mapped to a different column (e.g., Expected Qty)
            if (!isValueMappedElsewhere) {
              editDataItem[colItem?.sColumnID] = editItem[colItem?.inputType?.component?.sName];
            } else {
              editDataItem[colItem?.sColumnID] = "0";
            }

            if (shouldFetchQty) {
              await fetchQuantityOptionsForItem({
                itemCode: editItem["sInventoryCode"],
                itemData: editItem,
              });
            }
          }
           else if(colItem?.sColumnID == "col_disc"){
            const value = editItem[colItem?.inputType?.component?.sName];
            if(value?.includes("%")){
              editDataItem["col_disc_select"] = "%";
            } else {
              editDataItem["col_disc_select"] = "Fix";
            }
            editDataItem[colItem?.sColumnID] = editItem[colItem?.inputType?.component?.sName]?.replaceAll("%", "")?.replaceAll("Fix", "");
          } else if (!isValueMappedElsewhere) {
            editDataItem[colItem?.sColumnID] = editItem[colItem?.inputType?.component?.sName];
          }
          if(editItem?.sInventoryCode){
          setTableColOptions((prev) => ({ ...prev, [editItem.sInventoryCode]: editItem }));
          }
        });
        // Apply sMapping AFTER column mapping so item master data (e.g., sAccountCode)
        // overwrites any undefined values from the source document
        if (colItemIndex !== -1) {
          const mappingDetails = data?.fixcolumns?.[colItemIndex]?.sMapping;
          if (mappingDetails) {
            const valueField = data?.fixcolumns?.[colItemIndex]?.inputType?.data?.sValueField;
            const itemValue = editItem[data?.fixcolumns?.[colItemIndex]?.inputType?.component?.sName];
            const colItemData = itemOptionsForMapping?.find(opt => opt?.[valueField] === itemValue);
            if (colItemData) {
              const mappingFields = mapDataForMappingDetails(mappingDetails, colItemData);
              Object.assign(editDataItem, mappingFields);
            }
          }
        }
        // Map col_sExpectedType and sExpectedUnitConversion from documentSelectmappingData
        if (documentSelectmappingData?.["col_sExpectedType"]) {
          const expectedTypeField = documentSelectmappingData["col_sExpectedType"];
          const rawValue = editItem[expectedTypeField];
          if (rawValue) {
            const unitParts = rawValue?.split(":") || [];
            const unitCode = unitParts[0] || rawValue;
            const conversionValue = unitParts[1] ? Number(unitParts[1]) : 0;
            editDataItem["col_sExpectedType"] = unitCode;
            editDataItem["sExpectedUnitConversion"] = `${unitCode}:${formatWithTwoDecimals(conversionValue)}`;
          }
        }
        // Also map child columns (e.g., payment table columns like Invoice Date, Balance Due, etc.)
        data?.child?.forEach((childItem) => {
          const childColId = childItem?.inputtable?.sColumnID;
          const childComponentName = childItem?.component?.sName;
          // Use documentSelectmappingData to resolve original field name if direct name not found
          const mappedFieldName = documentSelectmappingData?.[childColId];
          const resolvedName = editItem[childComponentName] !== undefined ? childComponentName : mappedFieldName;
          if (childColId && resolvedName && editItem[resolvedName] !== undefined) {
            let value = editItem[resolvedName];
            // Format date fields using sSourceFormat -> sDisplayFormat from backend
            const sourceFormat = childItem?.component?.sSourceFormat;
            const displayFormat = childItem?.component?.sDisplayFormat;
            if (sourceFormat && displayFormat && value) {
              const dateStr = String(value).split(" ")[0]; // strip time portion
              const srcParts = sourceFormat.split("-");
              const dateParts = dateStr.split("-");
              if (srcParts.length === 3 && dateParts.length === 3) {
                const dateMap = {};
                srcParts.forEach((token, i) => { dateMap[token] = dateParts[i]; });
                value = displayFormat.replace(/YYYY|MM|DD/g, (token) => dateMap[token] || token);
              }
            }
            editDataItem[childColId] = value;
          }
        });
        loadFromRows?.push(editDataItem);
      });
      const itemObj = documentSelectTableData?.[0]?.tablesummary?.filter((summItem) => summItem?.sSummaryID === "summ_shipping")?.[0];
      const shippingObj = data?.summaryfields?.sSummaryDetails?.filter((summData) => summData?.sSummaryID === "summ_shipping")?.[0];
      if(itemObj && shippingObj){
        setSummaryExtras((prev) => {
          const index = prev.findIndex((extra) => extra.itemName === itemObj.sSummaryID);
          let extraData;
          if (index === -1) {
            extraData = [
              ...prev,
              {
                itemName: itemObj.sSummaryID,
                itemObj: shippingObj,
                value: itemObj?.sValue,
              },
            ];
          } else {
            extraData = [...prev];
            extraData[index] = {
              ...extraData[index],
              itemObj: shippingObj,
              value: itemObj?.sValue,
            };
          }
          setRows(
            runCalculations({
              passedRows: loadFromRows,
              summaryExtrasOverride: extraData,
              selectedTaxOverride: loadedTaxCalculation,
              colTaxOptionsOverride: fetchedTaxOptions || [],
              withholdingValueOverride:
                loadedWithholding.value,
              withholdingSelectOverride:
                loadedWithholding.select,
            })
          );
          return extraData;
        });
      } else {
        setRows(
          runCalculations({
            passedRows: loadFromRows,
            selectedTaxOverride:
              loadedTaxCalculation,
            colTaxOptionsOverride:
              fetchedTaxOptions || [],
            withholdingValueOverride:
              loadedWithholding.value,
            withholdingSelectOverride:
              loadedWithholding.select,
          })
        );
      }
    })();
  }, [documentSelectTableData])

  // Handle eventSelectTableData from EVENT component (e.g., when customer is selected in payment form)
  useEffect(() => {
    const tableDetailsFromDoc = eventSelectTableData?.data?.tablerecords?.[0]?.tabledetails;
    const tableRecordsDirect = eventSelectTableData?.data?.tablerecords;

    // If tabledetails is null, show loading state (unless sDataAware field is not selected)
    if (tableDetailsFromDoc === null) {
      // Check if sDataAware field is selected
      const sDataAwareField = data?.data?.sDataAware?.replace(/[{}]/g, "");
      if (sDataAwareField) {
        const sDataAwareValue = textValue?.[sDataAwareField];

        // If sDataAware field is not selected, show "No records" instead of loading
        if (!sDataAwareValue) {
          setIsLoading(false);
          setRows([]);
          return;
        }
      }
      setIsLoading(true);
      return;
    }

    // If tabledetails is empty array, clear the table for tables with sDataAware dependency
    if (Array.isArray(tableDetailsFromDoc) && tableDetailsFromDoc.length === 0) {
      const hasSDataAware = data?.data?.sDataAware;
      const isPaymentTable = data?.fixcolumns?.some(
        (col) => String(col?.bVisible) === "true" && col?.sColumnID === "col_rate" && Number(col?.inputType?.data?.bPayload) === 1
      ) && !data?.fixcolumns?.some((col) => col?.sColumnID === "col_qty");

      if (isPaymentTable || data?.data?.bCascade || hasSDataAware) {
        setRows([]);
      }
      setIsLoading(false);
      return;
    }

    const hasDocFormat = tableDetailsFromDoc && tableDetailsFromDoc.length > 0;
    const hasDirectFormat = Array.isArray(tableRecordsDirect) && tableRecordsDirect.length > 0 && !tableRecordsDirect[0]?.tabledetails;

    if (!hasDocFormat && !hasDirectFormat) {
      // For tables with sDataAware, ensure loading is false so "No records" can be displayed
      const hasSDataAware = data?.data?.sDataAware;
      if (data?.data?.bCascade || hasSDataAware) {
        setIsLoading(false);
      }
      return;
    }

    setIsLoading(false);

    const loadFromRows = [];
    const tableRecords = hasDocFormat ? tableDetailsFromDoc : tableRecordsDirect;

    const labelToApiFieldMap = {
      "invoice date": ["dtDate", "dtInvoiceDate", "InvoiceDate"],
      "invoice number": ["sDocNumber", "sInvoiceNumber", "InvoiceNumber", "DocNumber"],
      "invoice no": ["sDocNumber", "sInvoiceNumber", "InvoiceNumber", "DocNumber"],
      "ref doc": ["sReferenceDoc", "sRefDoc", "ReferenceDoc", "RefDoc"],
      "reference doc": ["sReferenceDoc", "sRefDoc", "ReferenceDoc", "RefDoc"],
      "ref number": ["sReferenceNumber", "sRefNumber", "ReferenceNumber", "RefNumber"],
      "reference number": ["sReferenceNumber", "sRefNumber", "ReferenceNumber", "RefNumber"],
      "due date": ["dtDueDate", "DueDate"],
      "balance": ["dAmount", "AmountIn", "dBalance", "Balance", "dBalanceDue", "BalanceDue"],
      "balance due": ["dAmount", "AmountIn", "dBalance", "Balance", "dBalanceDue", "BalanceDue"],
      "amount": ["dAmount", "AmountIn", "Amount"],
      "payment": ["dPayment", "Payment", "AmountPaid"]
    };

    tableRecords.forEach((record, index) => {
      const rowDataItem = { id: index + 1 };

      // Use eventSelectTableMapping if available
      if (eventSelectTableMapping && Object.keys(eventSelectTableMapping).length > 0) {
        Object.entries(eventSelectTableMapping).forEach(([colId, sourceField]) => {
          if (record[sourceField] !== undefined) {
            let value = record[sourceField];

            // Find the column definition to check formatting requirements
            const colDef = data?.fixcolumns?.find(col => col?.sColumnID === colId);
            const colLabel = (colDef?.sLabel || "").toLowerCase().trim();

            // Apply date formatting for date columns (MM-DD-YYYY display format)
            const isDateColumn = colLabel.includes("date") ||
                                 sourceField.toLowerCase().includes("date") ||
                                 sourceField.toLowerCase().startsWith("dt");
            if (isDateColumn && value) {
              const dateStr = String(value);
              // If already in MM-DD-YYYY format, keep it
              if (!/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
                // Convert from YYYY-MM-DD or YYYY-MM-DD HH:mm:ss to MM-DD-YYYY
                const datePart = dateStr.split(" ")[0];
                const parts = datePart.split("-");
                if (parts.length === 3 && parts[0].length === 4) {
                  value = `${parts[1]}-${parts[2]}-${parts[0]}`;
                }
              }
            }

            // Apply currency formatting for balance/amount columns
            const isCurrencyColumn = colId.includes("balance") ||
                                     colId.includes("amount") ||
                                     sourceField.toLowerCase().includes("balance") ||
                                     sourceField.toLowerCase().includes("amount");

            if (isCurrencyColumn && value !== null && value !== undefined && value !== "" && !isNaN(value)) {
              const numValue = parseFloat(value);
              value = numValue.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
            }

            rowDataItem[colId] = value;
          }
        });
      }

      // Map each column using label-based matching (fallback)
      data?.fixcolumns?.forEach((colItem) => {
        const colId = colItem?.sColumnID;
        const colLabel = (colItem?.sLabel || "").toLowerCase().trim();
        const colName = colItem?.inputType?.component?.sName;

        if (rowDataItem[colId] !== undefined) return;

        for (const [labelKey, apiFields] of Object.entries(labelToApiFieldMap)) {
          if (colLabel.includes(labelKey)) {
            for (const apiField of apiFields) {
              if (record[apiField] !== undefined && record[apiField] !== null) {
                let value = record[apiField];

                // Format currency fields (balance, amount) with thousand separator and 2 decimals
                const isCurrencyLabel = labelKey.includes("balance") || labelKey.includes("amount");
                if (isCurrencyLabel && !isNaN(value)) {
                  const numValue = parseFloat(value);
                  value = numValue.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  });
                }

                rowDataItem[colId] = value;
                break;
              }
            }
            break;
          }
        }

        if (rowDataItem[colId] === undefined) {
          if (colName && record[colName] !== undefined) {
            rowDataItem[colId] = record[colName];
          } else if (record[colId] !== undefined) {
            rowDataItem[colId] = record[colId];
          }
        }
      });

      Object.keys(record).forEach((key) => {
        // Don't overwrite col_balance_due - it's already set with proper formatting
        if (key === "col_balance_due" && rowDataItem[key] !== undefined) {
          return;
        }

        if (rowDataItem[key] === undefined) {
          let value = record[key];

          // Format currency fields (balance, amount, payment) with thousand separator and 2 decimals
          const isCurrencyKey = key.toLowerCase().includes("balance") ||
                                key.toLowerCase().includes("amount") ||
                                (key.toLowerCase().includes("payment") && key !== "sPaymentTerms");

          if (isCurrencyKey && value !== null && value !== undefined && value !== "" && !isNaN(value)) {
            const numValue = parseFloat(value);
            value = numValue.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
          }

          rowDataItem[key] = value;
        }
      });

      loadFromRows.push(rowDataItem);
    });

    if (loadFromRows.length > 0) {
      setRows(runCalculations({ passedRows: loadFromRows }));
    }
  }, [eventSelectTableData, eventSelectTableMapping])

  useEffect(() => {
    if(formAction !== "EDIT"){
      return;
    }
    const mainRecordDetails = parseFreeFormMainrecordDetails(freeFormTabbleEditMainrecord?.[data?.component?.sName]);
    if (mainRecordDetails) {
      setPriceSelect(mainRecordDetails?.priceoption || "Manual");
      setSelectedTax(mainRecordDetails?.taxcalculation || "");
      setSelectedCurrency(
        mainRecordDetails?.currency ||
        freeFormTabbleEditMainrecord?.sCurrency ||
        ""
      );
    }

    const withholdingSummary =
      persistedDefaultTable
        ?.tablesummary
        ?.find(
          item =>
            item?.sSummaryID ===
            "summ_withholding"
        );

    const loadedWithholding =
      parseWithholdingSummary(
        withholdingSummary
      );

    setWithholdingCode(
      loadedWithholding.code
    );

    setWithholdingValue(
      loadedWithholding.value
    );

    setWithholdingSelect(
      loadedWithholding.select
    );
    const editedRows = [];
    const colItemIndex = data?.fixcolumns?.findIndex(
      (col) => col.sColumnID == "col_item",
    );
    persistedDefaultTable?.tabledetails?.forEach((editItem, index) => {
      const editDataItem = { id: index + 1 };
      data?.fixcolumns?.forEach(async (colItem) => {
        if(colItem?.sColumnID == "col_item"){
          const mappingDetails = data?.fixcolumns?.[colItemIndex]?.sMapping;
          const mappingFields = mapDataForMappingDetails(mappingDetails, editItem || {});
          Object.assign(editDataItem, mappingFields);
        }
        // Check if this fixcolumn's source field is mapped to a DIFFERENT column
        const sourceFieldName = colItem?.inputType?.component?.sName;
        const isValueMappedElsewhere = documentSelectmappingData && sourceFieldName &&
          Object.entries(documentSelectmappingData).some(
            ([destCol, srcField]) => srcField === sourceFieldName && destCol !== colItem?.sColumnID
          );

        if (colItem?.sColumnID === "col_qty") {
          const unitParts = editItem["sUnitConversion"]?.split(":") || [];
          const unitCode = unitParts[0] || "";
          const conversionValue = unitParts[1] ? Number(unitParts[1]) : 0;

          editDataItem["col_qty_select"] = unitCode;
          editDataItem["sUnitConversion"] = `${unitCode}:${formatWithTwoDecimals(conversionValue)}`;
          // Only map value if it's not mapped to a different column (e.g., Expected Qty)
          if (!isValueMappedElsewhere) {
            editDataItem[colItem?.sColumnID] = editItem[colItem?.inputType?.component?.sName];
          } else {
            editDataItem[colItem?.sColumnID] = "0";
          }

          
          await fetchQuantityOptionsForItem({
            itemCode: editItem["sInventoryCode"],
            itemData: editItem,
          });
        }
        else if(colItem?.sColumnID == "col_disc"){
          const value = editItem[colItem?.inputType?.component?.sName];
          if(value?.includes("%")){
            editDataItem["col_disc_select"] = "%";
          } else {
            editDataItem["col_disc_select"] = "Fix";
          }
          editDataItem[colItem?.sColumnID] = editItem[colItem?.inputType?.component?.sName]?.replaceAll("%", "")?.replaceAll("Fix", "");
        } else if (!isValueMappedElsewhere) {
          editDataItem[colItem?.sColumnID] = editItem[colItem?.inputType?.component?.sName];
        }
        if(editItem?.sInventoryCode){
        setTableColOptions((prev) => ({ ...prev, [editItem.sInventoryCode]: editItem }));
        }
      });
      // Map sExpectedUnitConversion for Expected Qty unit (EDIT flow)
      if (editItem["sExpectedUnitConversion"]) {
        const rawValue = editItem["sExpectedUnitConversion"];
        const unitParts = rawValue?.split(":") || [];
        const unitCode = unitParts[0] || rawValue;
        const conversionValue = unitParts[1] ? Number(unitParts[1]) : 0;
        editDataItem["col_sExpectedType"] = unitCode;
        editDataItem["sExpectedUnitConversion"] = `${unitCode}:${formatWithTwoDecimals(conversionValue)}`;
      }
      // Also map child columns (e.g., payment table columns like Invoice Date, Balance Due, etc.)
      data?.child?.forEach((childItem) => {
        const childColId = childItem?.inputtable?.sColumnID;
        const childComponentName = childItem?.component?.sName;
        if (childColId && childComponentName && editItem[childComponentName] !== undefined) {
          let value = editItem[childComponentName];
          // Format date fields using sSourceFormat -> sDisplayFormat from backend
          const sourceFormat = childItem?.component?.sSourceFormat;
          const displayFormat = childItem?.component?.sDisplayFormat;
          if (sourceFormat && displayFormat && value) {
            const dateStr = String(value).split(" ")[0]; // strip time portion
            const srcParts = sourceFormat.split("-");
            const dateParts = dateStr.split("-");
            if (srcParts.length === 3 && dateParts.length === 3) {
              const dateMap = {};
              srcParts.forEach((token, i) => { dateMap[token] = dateParts[i]; });
              value = displayFormat.replace(/YYYY|MM|DD/g, (token) => dateMap[token] || token);
            }
          }
          editDataItem[childColId] = value;
        }
      });
      editedRows?.push(editDataItem);
    });

    const itemObj = persistedDefaultTable?.tablesummary?.filter((summItem) => summItem?.sSummaryID === "summ_shipping")?.[0];
    const shippingObj = data?.summaryfields?.sSummaryDetails?.filter((summData) => summData?.sSummaryID === "summ_shipping")?.[0];
    if(itemObj && shippingObj){
      setSummaryExtras((prev) => {
        const index = prev.findIndex((extra) => extra.itemName === itemObj.sSummaryID);
        let extraData;
        if (index === -1) {
          extraData = [
            ...prev,
            {
              itemName: itemObj.sSummaryID,
              itemObj: shippingObj,
              value: itemObj?.sValue,
            },
          ];
        } else {
          extraData = [...prev];
          extraData[index] = {
            ...extraData[index],
            itemObj: shippingObj,
            value: itemObj?.sValue,
          };
        }
        setRows(
          runCalculations({
            passedRows: editedRows,
            summaryExtrasOverride: extraData,
            withholdingValueOverride:
              loadedWithholding.value,
            withholdingSelectOverride:
              loadedWithholding.select,
          })
        );
        return extraData;
      });
    } else {
      setRows(
        runCalculations({
          passedRows: editedRows,
          withholdingValueOverride:
            loadedWithholding.value,
          withholdingSelectOverride:
            loadedWithholding.select,
        })
      );
    }
  }, [persistedDefaultTable, freeFormTabbleEditMainrecord, colTaxOptions, documentSelectmappingData]);

  const hydratedSummaryData = useMemo(() => {
    const basePayload = data?.summaryfields?.sSummaryDetails
      ?.filter(
        summItem =>
          summItem?.inputType?.data?.bPayload != 0 &&
          summItem?.sSummaryID != "summ_tax"
      )
      ?.map(summItem => ({
        sSummaryID: summItem?.sSummaryID,
        sAccountCode: "",
        sInputValue: "",
        sValue: ""
      }))
      ?? [];

    const mergedPayload = basePayload
      .filter(item => item.sSummaryID !== "summ_tax")
      .map(item => {
        const value = summaryCalculations?.[item.sSummaryID] ?? "";

        if (item.sSummaryID === "summ_withholding") {
          return {
            ...item,
            sInputValue: withholdingCode
              ? `${withholdingCode}:${withholdingValue}${withholdingSelect}`
              : "",
            sValue: toNumber(value)
          };
        }

        return {
          ...item,
          sValue: value === "" ? "" : toNumber(value)
        };
      });

    const summTaxConfig = data?.summaryfields?.sSummaryDetails?.find(
      s => s?.sSummaryID === "summ_tax"
    );

    const summTaxBPayload = summTaxConfig?.inputType?.data?.bPayload;

    if (summaryCalculations?.taxCalculations && summTaxBPayload != 0) {
      Object.entries(summaryCalculations.taxCalculations).forEach(([taxCode, taxObj]) => {
        if (taxCode === "undefined" || taxCode === undefined) return;

        const taxValue = taxObj?.afterTax ?? "";

        mergedPayload.push({
          sSummaryID: "summ_tax",
          sAccountCode: "",
          sInputValue: taxCode,
          sValue: taxValue
        });
      });
    }

    return mergedPayload;
  }, [
    data,
    summaryCalculations,
    withholdingCode,
    withholdingValue,
    withholdingSelect
  ]);

  useEffect(() => {
    setDefaultTableSummaryData(hydratedSummaryData);
  }, [hydratedSummaryData, setDefaultTableSummaryData]);

  const fetchQuantityOptionsForItem = useCallback(
    async ({ itemCode, itemData, shouldPublish = () => true }) => trackRequest(async () => {
      const colItemIndex = data?.fixcolumns?.findIndex(
        (col) => col.sColumnID === "col_qty",
      );
      if (colItemIndex === -1) return null;

      try {
        const response = await fetch(
          `${baseURL}${replaceBracketPlaceholders(
            data?.fixcolumns?.[colItemIndex]?.inputType?.data?.sDataSource,
            itemData,
          )}`,
          {
            method: "GET",
            headers: {
              Accept: "*/*",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const resData = await response.json();
        const records = resData?.data?.records || [];

        if (shouldPublish()) {
          setQuantitySelectOptions((prevData) => ({
            ...prevData,
            [itemCode]: records,
          }));
        }

        return (
          records?.[0] || null
        );
      } catch (error) {
        console.error("Error: ", error);
        return null;
      }
    }),
    [data, token, trackRequest],
  );

  function getPercent(item) {
    let filteredItems;
    filteredItems = colTaxOptions.filter(elm => elm.sTaxCode == item);
    return filteredItems.map(elm => elm.dPercentage);
  }

  function getVATPercentage(vatString) {
    if (typeof vatString === "string") {
      const matches = vatString && vatString?.match(/\((\d+(\.\d+)?)%\)/);

      if (matches && matches[1]) {
        return parseFloat(matches[1]);
      }
      return "";
    } else {
      return vatString;
    }
  }

  function toNumber(val) {
    return parseFloat(String(val ?? "0").replaceAll(",", "")) || 0;
  }
  
  const isZeroTotalNotAllowed = () => {
    const allowZeroValue = data?.component?.totals?.allowZeroValue;

    const zeroNotAllowed =
        allowZeroValue === false ||
        allowZeroValue === "false" ||
        allowZeroValue === 0 ||
        allowZeroValue === "0";

      if (!zeroNotAllowed) return false;

      const grandTotal = toNumber(summaryCalculations?.summ_grandtotal);

      return grandTotal === 0;
    };

  const calculateSummaryActionValue = useCallback((baseAmount, inputValue, action) => {
    const base = toNumber(baseAmount);
    const value = toNumber(inputValue);

    switch (action) {
      case "MULTIPLY":
        return base * value;

      case "DIVIDE":
        return value === 0 ? 0 : base / value;

      case "ADD":
      case "SUBTRACT":
      default:
        if (withholdingSelect === "%") {
          return base * (value / 100);
        }

        return value;
    }
  }, [withholdingSelect]);

  const runCalculations = useCallback(
      ({
        passedRows,
        summaryExtrasOverride = summaryExtras,
        selectedTaxOverride,
        colTaxOptionsOverride,
        withholdingValueOverride,
        withholdingSelectOverride,
      }) => {
      const calculatedRows = JSON.parse(JSON.stringify(passedRows || []));
      const effectiveTax =
        selectedTaxOverride !== undefined ? selectedTaxOverride : selectedTax;
      const effectiveTaxOptions =
        colTaxOptionsOverride !== undefined ? colTaxOptionsOverride : colTaxOptions;

      const effectiveWithholdingValue =
        withholdingValueOverride !== undefined
          ? withholdingValueOverride
          : withholdingValue;

      const effectiveWithholdingSelect =
        withholdingSelectOverride !== undefined
          ? withholdingSelectOverride
          : withholdingSelect;

      let subTotal = 0;
      let taxCalculations = {};

      const firstRow = calculatedRows[0] || {};

      const isPaymentTableByRowData =
        firstRow.col_dtInvoiceDate !== undefined ||
        firstRow.col_sInvoiceNumber !== undefined ||
        firstRow.col_dPayment !== undefined ||
        firstRow.dPayment !== undefined ||
        firstRow.col_dBalance !== undefined ||
        firstRow.dBalanceDue !== undefined;

      const hasRateQtyColumns = data?.fixcolumns?.some(
        col => col?.sColumnID === "col_rate" || col?.sColumnID === "col_qty"
      );

      const isPaymentTableByConfig = !hasRateQtyColumns;
      const isPaymentTable =
        isPaymentTableByConfig || (isPaymentTableByRowData && !hasRateQtyColumns);

      const isQtyVisible = data?.fixcolumns?.some(
        col => col?.sColumnID === "col_qty" && String(col?.bVisible) === "true"
      );

      calculatedRows.forEach(rowItem => {
        if (isPaymentTable) {
          subTotal += toNumber(rowItem?.col_rate);
          return;
        }

        const rate = toNumber(rowItem?.col_rate);
        const qty = isQtyVisible ? toNumber(rowItem?.col_qty) : 1;
        const disc = toNumber(rowItem?.col_disc);

        let amount = qty * rate;

        if (rowItem?.col_disc_select === "%") {
          amount -= amount * ((disc || 0) / 100);
        }

        if (rowItem?.col_disc_select === "Fix") {
          amount -= disc || 0;
        }

        let tax = 0;
        const taxPercent =
          getVATPercentage(
            effectiveTaxOptions
              ?.filter(elm => elm.sTaxCode == rowItem?.col_tax)
              ?.map(elm => elm.dPercentage)?.[0]
          ) || 0;

        if (effectiveTax === "Inclusive") {
          tax = amount * (taxPercent / (100 + taxPercent));
          amount -= tax;
        } else {
          tax = amount * (taxPercent / 100);
        }

        if (amount < 0) amount = 0;

        subTotal += Number(amount.toFixed(2));

        if (taxCalculations[rowItem?.col_tax]) {
          taxCalculations[rowItem?.col_tax].taxAmount = Number(
            ((taxCalculations[rowItem?.col_tax].taxAmount || 0) + tax).toFixed(2)
          );
          taxCalculations[rowItem?.col_tax].afterTax = Number(
            ((taxCalculations[rowItem?.col_tax].afterTax || 0) + amount).toFixed(2)
          );
        } else {
          taxCalculations[rowItem?.col_tax] = {
            taxAmount: Number((tax || 0).toFixed(2)),
            afterTax: Number((amount || 0).toFixed(2)),
          };
        }

        rowItem.col_amount = formatWithTwoDecimals(amount);
      });

      const totalTax = Object.values(taxCalculations).reduce(
        (sum, tax) => sum + (parseFloat(tax?.taxAmount) || 0),
        0
      );

      let runningTotal = Number(subTotal || 0) + Number(totalTax || 0);

      const summaryActionResults = {};
      let withholdingAmount = 0;

      const visibleSummaryItems = data?.summaryfields?.sSummaryDetails || [];

      visibleSummaryItems.forEach(summaryItem => {
        const summaryId = summaryItem?.sSummaryID;
        const action = summaryItem?.sAction;

        if (!summaryId || summaryId === "summ_subtotal" || summaryId === "summ_tax" || summaryId === "summ_grandtotal") {
          return;
        }

        let derivedValue = 0;

        if (summaryId === "summ_withholding") {
          const inputValue = toNumber(
            effectiveWithholdingValue
          );

          if (
            effectiveWithholdingSelect === "%"
          ) {
            derivedValue = Number(
              (
                subTotal *
                (inputValue / 100)
              ).toFixed(2)
            );
          } else {
            derivedValue = Number(
              inputValue.toFixed(2)
            );
          }

          withholdingAmount = derivedValue;
        } else {
          const extra = summaryExtrasOverride?.find(
            item => item?.itemName === summaryId
          );

          if (!extra) return;

          derivedValue = toNumber(extra?.value);
        }

        switch (action) {
          case "ADD":
            runningTotal += derivedValue;
            break;

          case "SUBTRACT":
            runningTotal -= derivedValue;
            break;

          case "MULTIPLY":
            runningTotal *= derivedValue;
            break;

          case "DIVIDE":
            runningTotal = derivedValue === 0 ? runningTotal : runningTotal / derivedValue;
            break;

          default:
            break;
        }

        summaryActionResults[summaryId] = formatWithTwoDecimals(derivedValue);
      });

      const grandTotal = Number(runningTotal).toFixed(2);

      const nextSummaryCalculations = {
        summ_subtotal: Number(subTotal || 0).toFixed(2),
        taxCalculations,
        summ_withholding: Number(withholdingAmount || 0).toFixed(2),
        summ_grandtotal: grandTotal,
        ...summaryActionResults,
      };

      setSummaryCalculations(nextSummaryCalculations);

      if (toNumber(nextSummaryCalculations.summ_grandtotal) > 0) {
        setSummaryErrors(prev => {
          if (!prev?.summ_grandtotal) return prev;

          const next = { ...prev };
          delete next.summ_grandtotal;
          return next;
        });
      }

      return calculatedRows;
    },
    [
      data,
      selectedTax,
      colTaxOptions,
      summaryExtras,
      withholdingValue,
      withholdingSelect,
    ]
  );

  useEffect(() => {
    if (!data?.data?.bCascade) return;
    if (!cascadeDataSource) return;
    if (!sDataAwareField) return;

    if (!sDataAwareValue) {
      cascadeRequestControllerRef.current.clear();
      setRows([]);
      setIsLoading(false);
      return;
    }

    if (
      !resolvedCascadeSource ||
      hasUnresolvedPlaceholders(resolvedCascadeSource)
    ) {
      return;
    }

    const request = cascadeRequestControllerRef.current.begin(
      resolvedCascadeSource,
    );

    if (!request) return;

    const isCurrentRequest = () =>
      cascadeRequestControllerRef.current.isCurrent(request);

    const fetchCascadeRows = async () => {
      try {
        setIsLoading(true);

        const url = resolvedCascadeSource.startsWith("/")
          ? `${baseURL}${resolvedCascadeSource}`
          : `${baseURL}/${resolvedCascadeSource}`;

        const response = await fetch(url, {
          method: "GET",
          signal: request.signal,
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        });

        const result = await response.json();

        if (!isCurrentRequest()) return;

        const records =
          result?.data?.records ||
          result?.data ||
          [];

        const mapping = data?.data?.sMapping || {};

        const defaultRow = {};

        data?.fixcolumns?.forEach(col => {
          if (col?.inputType?.component?.iDecimalPlaces) {
            defaultRow[col.sColumnID] = formatWithTwoDecimals(
              Number(col?.inputType?.component?.sDefaultValue || 0)
            );
          } else {
            defaultRow[col.sColumnID] =
              col?.inputType?.component?.sDefaultValue ?? "";
          }
        });

        data?.child?.forEach(child => {
          defaultRow[child?.inputtable?.sColumnID] =
            child?.component?.sDefaultValue ?? "";
        });

        const mappedRows = records.map((record, index) => {
          const row = {
            id: index + 1,
            ...defaultRow
          };

          Object.entries(mapping).forEach(([sourceField, targetColumn]) => {
            row[targetColumn] = record?.[sourceField] ?? "";
          });

          return row;
        });

        setRows(runCalculations({ passedRows: mappedRows }));
      } catch (error) {
        if (request.signal.aborted || error?.name === "AbortError") {
          return;
        }

        if (!isCurrentRequest()) return;

        cascadeRequestControllerRef.current.fail(request);
        console.error("Error fetching cascade INPUTTABLE DEFAULT data:", error);
        setRows([]);
        setIsLoading(false);
      } finally {
        if (isCurrentRequest()) {
          cascadeRequestControllerRef.current.complete(request);
          setIsLoading(false);
        }
      }
    };

    fetchCascadeRows();
  }, [
    data?.data?.bCascade,
    cascadeDataSource,
    data?.data?.sMapping,
    sDataAwareField,
    sDataAwareValue,
    resolvedCascadeSource,
    token,
    runCalculations
  ]);

  useEffect(() => () => {
    cascadeRequestControllerRef.current.clear();
    quantityRequestOwnershipRef.current.clear();
  }, []);

  const quantityValueField = useMemo(() => {
    const quantityColumn = data?.fixcolumns?.find(
      column => column?.sColumnID === "col_qty",
    );

    return quantityColumn?.inputType?.data?.sValueField || "sRelativeUnitCode";
  }, [data?.fixcolumns]);

  useEffect(() => {
    setRows(previousRows => reconcileUnitConversionRows(
      previousRows,
      quantitySelectOptions,
      quantityValueField,
    ));
  }, [rows, quantitySelectOptions, quantityValueField]);

  function calculateConversionString(grandTotal) {
    const selectedCurrencyObject = currencyOptions?.filter((currItem) => currItem?.sCurrencyCode === selectedCurrency?.split(":")?.[0])?.[0];
    const exchangeRate = selectedCurrencyObject?.dExchangeRate || 0;
    const conversionAmount = formatWithTwoDecimals((grandTotal || (toNumber(summaryCalculations?.summ_grandtotal || 0))) * exchangeRate); 
    const conversionString = `${data?.component?.currency?.sDefaultValue} ${conversionAmount} @ ${selectedCurrency?.split(":")?.[0]} 1 = ${data?.component?.currency?.sDefaultValue} ${formatWithTwoDecimals(exchangeRate)}`;
    setCurrencyConversion(conversionString);
  }

  async function fetchColItemForPriceSelect(uri, rowData) {
    const resolvedUri = replaceBracketPlaceholders(uri, rowData);

    if (!resolvedUri || hasUnresolvedPlaceholders(resolvedUri)) {
      return undefined;
    }

    return trackRequest(async () => {
    try {
      const url = `${baseURL}${resolvedUri}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      });
  
      const result = await response.json();
      return result?.data?.records?.[0];
    } catch (error) {
      console.log(error);
    }
    });
  }

useEffect(() => {
  if (rows?.length > 0) {
    setRows(prev => runCalculations({ passedRows: prev }));
  }
}, [withholdingValue, withholdingSelect]);

  useEffect(() => {
    calculateConversionString();
  }, [selectedCurrency, summaryCalculations])

  useEffect(() => {
    const updatedRows = runCalculations({ passedRows: rows, summaryExtrasOverride: summaryExtras });
    if(updatedRows?.length > 0){
      setRows(updatedRows);
    }
  }, [selectedTax]);

  // useEffect(() => {
  //   if((!quantitySelectOptions || quantitySelectOptions?.length == 0) && (formAction === "EDIT" || documentSelectTableData?.length != 0)){
  //     return;
  //   }
  //   setIsLoading(true);
  //   let priceField = "";
  //   Object.entries(data?.pricingOptions)?.forEach((priceItemArray) => {
  //     if (priceItemArray[0] === priceSelect) {
  //       priceField = (priceItemArray[1]?.sPriceField)?.replaceAll("{", "")?.replaceAll("}", "");
  //     }
  //   });

  //   if (!priceField) {
  //     setIsLoading(false);
  //     return;
  //   }

  //   (async () => {
  //     try {
  //       const updatedRows = await Promise.all(
  //         rows.map(async (row) => {
  //           if (!row?.col_item) return row;
  //           try {
  //             const res = await fetchColItemForPriceSelect(
  //               data.pricingOptions[priceSelect].sDataSource,
  //               { ...textValue, sInventoryCode: row.col_item }
  //             );
  //             const raw = res?.[priceField];
  //             const multiplier = quantitySelectOptions?.[row?.col_item]?.filter((qtyCode) => qtyCode?.sRelativeUnitCode == row?.col_qty_select)?.[0];
  //             if(multiplier){
  //               const conversion = Number(multiplier?.sConversion) || 1;
  //               return { ...row, col_rate: Number((raw * conversion) ?? 0).toFixed(2) };
  //             } else {
  //               return { ...row, col_rate: Number(raw ?? 0).toFixed(2) };
  //             }
  //           } catch {
  //             return row;
  //           }
  //         })
  //       );
  //       if (updatedRows?.length > 0) {
  //         setRows(runCalculations({ passedRows: updatedRows, summaryExtrasOverride: summaryExtras }));
  //       }
  //     } catch (err) {
  //       console.error(err);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   })();
  // }, [priceSelect]);



// Extract sDataAware fields whenever priceSelect or data changes
    useEffect(() => {
      const sDataAware = data?.pricingOptions?.[priceSelect]?.sDataAware;

      if (sDataAware) {
        const dataAwareArray = sDataAware
          .split(",")
          .map(item => item.replace(/[{}]/g, "").trim());

        const mappedDependencies = dataAwareArray.map(field => {
          switch (field) {
            case "sInventoryCode":
              return { field, value: inventoryCodeItem };
            case "sAccountTo":
              return { field, value: textValue?.sAccountTo };
            default:
              return { field, value: textValue?.[field] };
          }
        });

        // Only update state if values actually changed to prevent unnecessary re-renders
        setDataAware(prev => {
          const prevKey = prev.map(d => `${d.field}:${d.value}`).join("|");
          const newKey = mappedDependencies.map(d => `${d.field}:${d.value}`).join("|");
          if (prevKey === newKey) return prev; // same reference = no re-render
          return mappedDependencies;
        });

      } else {
        setDataAware(prev => prev.length === 0 ? prev : []);
      }
    }, [priceSelect, data, inventoryCodeItem, textValue?.sAccountTo]);


    // Stable primitive key for dataAware — only changes when actual values change
    const dataAwareKey = useMemo(
      () => dataAware.map(d => `${d.field}:${d.value}`).join("|"),
      [dataAware]
    );

    const priceRowDataKey = useMemo(() => {
      const priceOption = data?.pricingOptions?.[priceSelect];

      if (priceSelect === "Manual" || !priceOption?.sDataSource) return "";

      return JSON.stringify(
        rows.map(row => {
          const rowValues = { ...(textValue || {}), ...(row || {}) };

          Object.entries(allFieldNames || {}).forEach(([columnId, componentName]) => {
            const rowValue = row?.[columnId];

            if (componentName && rowValue !== undefined && rowValue !== null) {
              rowValues[componentName] = rowValue;
            }
          });

          return {
            rowId: row.id,
            dataSource: replaceBracketPlaceholders(priceOption.sDataSource, rowValues),
            quantityUnit: row?.col_qty_select || ""
          };
        })
      );
    }, [
      rows,
      textValue,
      allFieldNames,
      data?.pricingOptions,
      priceSelect
    ]);

    useEffect(() => {
      const requestId = ++pricingRequestSequenceRef.current;

      if ((!quantitySelectOptions || quantitySelectOptions?.length === 0) &&
          (formAction === "EDIT" || documentSelectTableData?.length !== 0)) {
        return;
      }

      setIsLoading(true);

      const priceOption = data?.pricingOptions?.[priceSelect];
      if (!priceOption) {
        setIsLoading(false);
        return;
      }

      const priceField = priceOption.sPriceField?.replaceAll("{", "").replaceAll("}", "");
      if (!priceField) {
        setIsLoading(false);
        return;
      }

    (async () => {
      try {
        const rowPricing = await Promise.all(
          rows.map(async row => {
            if (!row?.col_item) return null;

            const rowValues = { ...(textValue || {}), ...(row || {}) };

            Object.entries(allFieldNames || {}).forEach(([columnId, componentName]) => {
              const rowValue = row?.[columnId];

              if (componentName && rowValue !== undefined && rowValue !== null) {
                rowValues[componentName] = rowValue;
              }
            });

            const rowDataSource = replaceBracketPlaceholders(
              priceOption.sDataSource,
              rowValues
            );

            if (!rowDataSource || hasUnresolvedPlaceholders(rowDataSource)) return null;

            const response = await fetchColItemForPriceSelect(rowDataSource, {});
            const conversionDetails = quantitySelectOptions?.[row?.col_item]
              ?.find(qtyCode => qtyCode?.sRelativeUnitCode === row?.col_qty_select);

            return {
              rowId: row.id,
              rate: Number(
                Number(response?.[priceField] ?? 0) *
                (Number(conversionDetails?.sConversion) || 1)
              ).toFixed(2)
            };
          })
        );

        const rateByRow = new Map(
          rowPricing.filter(Boolean).map(result => [result.rowId, result.rate])
        );

        if (requestId !== pricingRequestSequenceRef.current) return;

        setRows(previousRows => {
          let changed = false;
          const updatedRows = previousRows.map(row => {
            const rate = rateByRow.get(row.id);

            if (rate === undefined || String(row.col_rate ?? "") === rate) {
              return row;
            }

            changed = true;
            return { ...row, col_rate: rate };
          });

          return changed
            ? runCalculations({
                passedRows: updatedRows,
                summaryExtrasOverride: summaryExtras
              })
            : previousRows;
        });
      } catch (err) {
        if (requestId === pricingRequestSequenceRef.current) {
          console.error(err);
        }
      } finally {
        if (requestId === pricingRequestSequenceRef.current) {
          setIsLoading(false);
        }
      }
    })();

    return () => {
      if (requestId === pricingRequestSequenceRef.current) {
        pricingRequestSequenceRef.current += 1;
      }
    };

  }, [
    priceSelect,
    dataAwareKey, // stable string — only changes when actual field values change
    priceRowDataKey,
    textValue?.sAccountTo
  ]);

  const handleRowUpdate = useCallback(
    async ({ rowId, fieldName, value, colItemData }) => {

      setRowErrors(prev => {
        if (!prev[rowId]?.[fieldName]) return prev;
        const updated = { ...prev, [rowId]: { ...prev[rowId] } };
        delete updated[rowId][fieldName];
        return updated;
      });

      let mappingFields = {};
 
      if (fieldName === "col_item"){
        const colItemIndex = data?.fixcolumns?.findIndex(
          (col) => col.sColumnID == "col_item",
        );

        const mappingDetails = data?.fixcolumns?.[colItemIndex]?.sMapping;
        mappingFields = mapDataForMappingDetails(mappingDetails, colItemData || {});
        if(colItemData?.sInventoryCode){
        setTableColOptions((prev) => ({ ...prev, [colItemData.sInventoryCode]: colItemData }));
        setSInventory(colItemData.sInventoryCode);
        }

        let priceField = "";
        Object.entries(data?.pricingOptions)?.forEach((priceItemArray) => {
          if(priceItemArray[0] === priceSelect){
            priceField = (priceItemArray[1]?.sPriceField);
          }
        });
        if(priceField){
          mappingFields.col_rate = (colItemData?.[priceField?.replaceAll("{", "")?.replaceAll("}", "")] || 0)?.toFixed(2);
        }

        // Commit the selected item before any dependent request. This keeps the
        // controlled autocomplete and subsequent row fields synchronized even
        // when quantity/UOM loading is slow.
        const quantityRequest = quantityRequestOwnershipRef.current.begin(
          rowId,
          value,
        );

        setRows((previousRows) => {
          const rowIndex = previousRows.findIndex((row) => row.id === rowId);
          if (rowIndex === -1) return previousRows;

          const previousRow = previousRows[rowIndex];
          const itemChanged = previousRow?.col_item !== value;

          const updatedRows = previousRows.slice();
          updatedRows[rowIndex] = {
            ...previousRow,
            [fieldName]: value,
            ...mappingFields,
            ...(itemChanged
              ? { col_qty_select: "", sUnitConversion: "" }
              : {}),
          };
          return runCalculations({ passedRows: updatedRows });
        });

        const fetchedQtyValue = await fetchQuantityOptionsForItem({
          itemCode: value,
          itemData: colItemData,
          shouldPublish: () =>
            quantityRequestOwnershipRef.current.isCurrent(quantityRequest),
        });
  
        if (
          fetchedQtyValue !== null &&
          quantityRequestOwnershipRef.current.isCurrent(quantityRequest)
        ) {
          const colQtyIndex = data?.fixcolumns?.findIndex(
            (col) => col.sColumnID === "col_qty",
          )
          const quantityValueField = data?.fixcolumns?.[colQtyIndex]
            ?.inputType?.data?.sValueField;
          const conversionPatch = buildUnitConversionPatch(
            fetchedQtyValue,
            quantityValueField,
          );

          setRows((previousRows) => {
            const rowIndex = previousRows.findIndex((row) => row.id === rowId);
            if (
              rowIndex === -1 ||
              previousRows[rowIndex]?.col_item !== value ||
              !quantityRequestOwnershipRef.current.isCurrent(quantityRequest) ||
              !conversionPatch
            ) {
              return previousRows;
            }

            const updatedRows = previousRows.slice();
            updatedRows[rowIndex] = {
              ...updatedRows[rowIndex],
              ...conversionPatch,
            };
            return runCalculations({ passedRows: updatedRows });
          });
        }

        return;
      }

      if (fieldName === "col_qty") {
        value = value?.toString() ?? "";
      }

      if (fieldName === "col_rate") {
        value = value?.toString() ?? "";
      }

      setRows((prev) => {
        const idx = prev.findIndex((r) => r.id === rowId);
        if (idx === -1) return prev;
        const currentRow = prev[idx];
        let currentMappingFields = mappingFields;

        if (fieldName === "col_qty_select") {
          const quantityColumn = data?.fixcolumns?.find(
            column => column?.sColumnID === "col_qty",
          );
          const quantityValueField = quantityColumn?.inputType?.data?.sValueField;
          const conversionDetails = colItemData ||
            quantitySelectOptions?.[currentRow?.col_item]?.find(
              option => option?.[quantityValueField] === value,
            );
          const conversionPatch = buildUnitConversionPatch(
            conversionDetails,
            quantityValueField,
          );

          currentMappingFields = conversionPatch ||
            (currentRow?.col_qty_select === value
              ? { sUnitConversion: currentRow?.sUnitConversion || "" }
              : { sUnitConversion: "" });
        }

        const newRows = prev.slice();
        newRows[idx] = {
          ...currentRow,
          [fieldName]: value,
          ...currentMappingFields,
        };
        const committedRows = reconcileUnitConversionRows(
          newRows,
          quantitySelectOptions,
          quantityValueField,
        );
        return runCalculations({ passedRows: committedRows });
      });
    },
    [
      runCalculations,
      priceSelect,
      quantitySelectOptions,
      quantityValueField,
      colTaxOptions,
    ],
  );

  const handleRowOrderChange = (params) => {
    if (params.oldIndex === params.targetIndex) return;

    const newRows = [...rows];
    const movedRow = newRows.splice(params.oldIndex, 1)[0];
    newRows.splice(params.targetIndex, 0, movedRow);

    setRows(newRows);
  }

  const handleAddRow = (e) => {
    const row = {};
    data?.fixcolumns?.forEach(col => {
      if(col?.inputType?.component?.iDecimalPlaces){
        row[col?.sColumnID] = formatWithTwoDecimals(Number(col?.inputType?.component?.sDefaultValue));
      } else {
        row[col?.sColumnID] = col?.inputType?.component?.sDefaultValue;
      }
    });
    data?.child?.forEach(child => {
      row[child?.inputtable?.sColumnID] = child?.component?.sDefaultValue;
    });

    const maxId = rows.reduce((max, r) => (r.id > max ? r.id : max), 0);

    if (e?.target?.value) {
      const numNewRows = parseInt(e.target.value);
      const newRows = Array.from({ length: numNewRows }, (_, i) => ({
        id: maxId + i + 1,
        ...row
      }));
      setRows(prevRows => [...prevRows, ...newRows]);
    } else {
      const newRow = {
        id: maxId + 1,
        ...row
      };
      setRows(prevRows => [...prevRows, newRow]);
    }
  };

  const handleAddRowAtIndex = (currentRowId) => {
    const row = {};
    
    data?.fixcolumns?.forEach(col => {
      if (col?.inputType?.component?.iDecimalPlaces) {
        row[col?.sColumnID] = formatWithTwoDecimals(
          Number(col?.inputType?.component?.sDefaultValue)
        );
      } else {
        row[col?.sColumnID] = col?.inputType?.component?.sDefaultValue;
      }
    });

    data?.child?.forEach(child => {
      row[child?.inputtable?.sColumnID] = child?.component?.sDefaultValue;
    });

    setRows(prevRows => {
      const maxId = prevRows.reduce((max, r) => (r.id > max ? r.id : max), 0);
      const newRow = {
        id: maxId + 1,
        ...row
      };

      if (currentRowId) {
        const index = prevRows.findIndex(r => r.id === currentRowId);
        if (index !== -1) {
          return [
            ...prevRows.slice(0, index + 1),
            newRow,
            ...prevRows.slice(index + 1),
          ];
        }
      }

      return [...prevRows, newRow];
    });
  };

 const handleRowClone = (sourceRowId) => {
  if (!sourceRowId) return;

  setRows(prevRows => {
    const sourceIndex = prevRows.findIndex(
      row => String(row.id) === String(sourceRowId)
    );

    if (sourceIndex === -1) return prevRows;

    const sourceRow = prevRows[sourceIndex];

    console.log("#CLONE_SOURCE_ROW", sourceRow);

    const maxId = prevRows.reduce(
      (max, row) => Math.max(max, Number(row.id || 0)),
      0
    );

    const newRow = {
      ...JSON.parse(JSON.stringify(sourceRow)),
      id: maxId + 1,
    };

    data?.fixcolumns?.forEach(col => {
      const colId = col?.sColumnID;
      const fieldName = col?.inputType?.component?.sName;

      if (!colId) return;

      newRow[colId] =
        sourceRow?.[colId] ??
        sourceRow?.[fieldName] ??
        "";

      if (fieldName && sourceRow?.[fieldName] !== undefined) {
        newRow[fieldName] = sourceRow[fieldName];
      }
    });

    data?.child?.forEach(child => {
      const colId = child?.inputtable?.sColumnID;
      const fieldName = child?.component?.sName;

      if (!colId) return;

      newRow[colId] =
        sourceRow?.[colId] ??
        sourceRow?.[fieldName] ??
        "";

      if (fieldName && sourceRow?.[fieldName] !== undefined) {
        newRow[fieldName] = sourceRow[fieldName];
      }
    });

    newRow.col_qty =
      sourceRow.col_qty ??
      sourceRow.dQuantity ??
      "";

    newRow.col_tax =
      sourceRow.col_tax ??
      sourceRow.sTaxCode ??
      "";

    newRow.col_qty_select = sourceRow.col_qty_select ?? "";
    newRow.sUnitConversion = sourceRow.sUnitConversion ?? "";
    newRow.col_disc_select = sourceRow.col_disc_select ?? "%";

    const nextRows = [
      ...prevRows.slice(0, sourceIndex + 1),
      newRow,
      ...prevRows.slice(sourceIndex + 1),
    ];

    return runCalculations({ passedRows: nextRows });
  });
};

  const handleDeleteRow = (rowID) => {
    setRows(prevRows => {
      const remainingRows = prevRows.filter(row => row.id !== rowID);

      if (remainingRows.length === 0) {
        const row = {};

        data?.fixcolumns?.forEach(col => {
          if (col?.inputType?.component?.iDecimalPlaces) {
            row[col?.sColumnID] = formatWithTwoDecimals(
              Number(col?.inputType?.component?.sDefaultValue || 0)
            );
          } else {
            row[col?.sColumnID] = col?.inputType?.component?.sDefaultValue ?? "";
          }
        });

        data?.child?.forEach(child => {
          row[child?.inputtable?.sColumnID] =
            child?.component?.sDefaultValue ?? "";
        });

        return runCalculations({
          passedRows: [{ id: 1, ...row }],
        });
      }

      return runCalculations({ passedRows: remainingRows });
    });
  };


  const columns = useMemo(
    () =>
      buildColumns({
        data,
        columnRenderers,
        colItemOptions,
        quantitySelectOptions,
        handleRowUpdate,
        colTaxOptions,
        colAccountOptions,
        handleDeleteRow,
        handleAddRowAtIndex,
        handleRowClone,
        disableRate: disabledPriceOptionRate?.includes(priceSelect),
        priceSelect,
        formAction,
        defaultTableSelectedLocation,
        documentSelectTableData,
        textValue,
        rowErrors,
      }),
    [
      data,
      columnRenderers,
      colItemOptions,
      quantitySelectOptions,
      handleRowUpdate,
      colTaxOptions,
      colAccountOptions,
      handleDeleteRow,
      handleAddRowAtIndex,
      handleRowClone,
      selectedTax,
      disabledPriceOptionRate,
      priceSelect,
      formAction,
      defaultTableSelectedLocation,
      documentSelectTableData,
      textValue,
      rowErrors,
    ],
  );

  // Hide auto-generated columns that we've explicitly defined
  const columnVisibilityModel = useMemo(() => {
    const model = {};
    const explicitFields = columns.map(col => col.field);

    // Hide any duplicate auto-generated columns
    if (rows.length > 0) {
      const rowFields = Object.keys(rows[0]);
      rowFields.forEach(field => {
        // Only show columns that are explicitly defined in our columns array
        // Hide all other auto-generated columns from raw API fields
        if (!explicitFields.includes(field)) {
          model[field] = false;
        }
      });
    }

    return model;
  }, [columns, rows]);

  const clearColumns = arr => {
    const items = { id: 1, disc_type: "%" };
    data?.fixcolumns?.forEach(
      item => (items[item?.sColumnID] = item?.inputType?.component?.sDefaultValue)
    );
    data?.child?.forEach(
      item => (items[item.inputtable.sColumnID] = item?.component.sDefaultValue)
    );
    let allfeilds = arr.sMapping.split(", ");

    const newVal = rows.map(item => {
      const newItem = { ...item };
      allfeilds.forEach(field => {
        if (newItem.hasOwnProperty(field)) {
          newItem[field] = items[field];
        }
      });
      return newItem;
    });
    setRows(runCalculations({ passedRows: newVal }));
  };

  const handleSummaryUpdate = (itemName, itemValue, item) => {
    setSummaryExtras((prev) => {
      const exists = prev.find((entry) => entry.itemName === itemName);

      const newSummary = exists
        ? prev.map((entry) =>
            entry.itemName === itemName
              ? { ...entry, value: itemValue, itemObj: item }
              : entry
          )
        : [...prev, { itemName, itemObj: item, value: itemValue }];      
      setRows(runCalculations({ passedRows: rows, summaryExtrasOverride: newSummary }));

      return newSummary;
    });
  };

  const resetTable = () => {
    const row = {};
    data?.fixcolumns?.forEach(col => {
      if(col?.inputType?.component?.iDecimalPlaces){
        row[col?.sColumnID] = formatWithTwoDecimals(Number(col?.inputType?.component?.sDefaultValue));
      } else {
        row[col?.sColumnID] = col?.inputType?.component?.sDefaultValue;
      }
    });
    data?.child?.forEach(child => {
      row[child?.inputtable?.sColumnID] = child?.component?.sDefaultValue;
    });

    const maxId = rows.reduce((max, r) => (r.id > max ? r.id : max), 0);
    const newRow = {
      id: maxId + 1,
      ...row
    };
    setRows([ newRow ]);
  }

  const openBulkLoad = (type) => {
    setBulkActionType(type);
    setBulkLoadData([]);
    setBulkLoadOpen(true);
  };

  const handleBulkLoad = async () => {
    // sMapping from backend: sourceField → colId  (e.g. "sInventoryCode": "col_item")
    const mapping = data?.component?.[bulkActionType]?.sMapping || {};

    const defaultRow = {};
    data?.fixcolumns?.forEach(col => {
      if (col?.inputType?.component?.iDecimalPlaces) {
        defaultRow[col?.sColumnID] = formatWithTwoDecimals(Number(col?.inputType?.component?.sDefaultValue));
      } else {
        defaultRow[col?.sColumnID] = col?.inputType?.component?.sDefaultValue;
      }
    });
    data?.child?.forEach(child => {
      defaultRow[child?.inputtable?.sColumnID] = child?.component?.sDefaultValue;
    });

    const colQtyIndex = data?.fixcolumns?.findIndex(col => col.sColumnID === "col_qty");

    const newRows = await Promise.all(BulkLoadData.map(async (item, index) => {
      const row = { ...defaultRow, id: index + 1 };
      for (const [sourceField, colId] of Object.entries(mapping)) {
        if (item[sourceField] !== undefined) {
          let value = item[sourceField];
          if (typeof value === 'number' && !isNaN(value)) {
            value = formatWithTwoDecimals(value);
          }
          row[colId] = value;
        }
      }

      // Fetch quantity unit options (pc, bx, etc.) same as manual item selection
      const itemCode = row['col_item'];
      if (itemCode && colQtyIndex !== -1) {
        const fetchedQtyValue = await fetchQuantityOptionsForItem({
          itemCode,
          itemData: item,
        });
        if (fetchedQtyValue) {
          row['col_qty_select'] = fetchedQtyValue?.[data?.fixcolumns?.[colQtyIndex]?.inputType?.data?.sValueField];
          row['sUnitConversion'] = `${fetchedQtyValue?.sRelativeUnitCode}:${formatWithTwoDecimals(Number(fetchedQtyValue?.sConversion || 0))}`;
        }
      }

      return row;
    }));

    setRows(runCalculations({ passedRows: newRows }));
    setBulkLoadOpen(false);
    setBulkLoadData([]);
  };

  function replaceKeys(obj, allfields) {
    const newObj = {};

    // Check if this is payment table data (has invoice-related fields)
    const isPaymentData = obj.col_dtInvoiceDate !== undefined ||
                          obj.col_sInvoiceNumber !== undefined ||
                          obj.dBalanceDue !== undefined;

    // Helper to format dates for API (MM-DD-YYYY → YYYY-MM-DD)
    const formatDateForAPI = (dateStr) => {
      if (!dateStr) return "";
      // If already in YYYY-MM-DD format, keep it
      if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
        return dateStr.split(" ")[0];
      }
      // Convert from MM-DD-YYYY to YYYY-MM-DD
      const parts = dateStr.split("-");
      if (parts.length === 3 && parts[0].length === 2) {
        return `${parts[2]}-${parts[0]}-${parts[1]}`;
      }
      return dateStr;
    };

    // Helper to remove commas from currency values
    const cleanCurrencyValue = (value) => {
      if (typeof value === "string") {
        return value.replace(/,/g, "");
      }
      return value;
    };

    // Payment table field mapping - map col_ prefixed fields to API expected names
    // ONLY include fields that the API expects for payment details
    const paymentFieldMapping = {
      'col_dtInvoiceDate': 'dtInvoiceDate',
      'col_sInvoiceDocType': 'sInvoiceDocType',
      'col_sInvoiceNumber': 'sInvoiceNumber',
      'col_sInvoiceRefNumber': 'sInvoiceRefNumber',
      'col_sInvoiceRefDoc': 'sInvoiceRefDoc',
      'col_dBalance': 'dBalance',
      'col_sInvoiceDueDate': 'dtInvoiceDueDate',
      'col_sInvoiceStatus': 'sInvoiceStatus',
      'col_rate': 'dRate',
      'col_amount': 'dAmount'
    };

    // Date fields that need formatting
    const dateFields = ['col_dtInvoiceDate', 'col_sInvoiceDueDate'];
    // Currency fields that need comma removal
    const currencyFields = ['col_dBalance', 'col_rate', 'col_amount'];

    // For payment data, ONLY include the mapped fields (filter out extra API response fields)
    if (isPaymentData) {
      // Always include id
      if (obj.id !== undefined) {
        newObj.id = obj.id;
      }
      // Map only the required fields
      for (const key in paymentFieldMapping) {
        const apiFieldName = paymentFieldMapping[key];
        let value = obj[key];

        // Format dates for API (MM-DD-YYYY → YYYY-MM-DD)
        if (dateFields.includes(key) && value) {
          value = formatDateForAPI(value);
        }

        // Remove commas from currency fields
        if (currencyFields.includes(key) && value) {
          value = cleanCurrencyValue(value);
        }

        // Always include dRate and dAmount, default to "0.00" if undefined
        if (apiFieldName === 'dRate' || apiFieldName === 'dAmount') {
          newObj[apiFieldName] = value !== undefined ? value : "0.00";
        } else if (value !== undefined) {
          newObj[apiFieldName] = value;
        }
      }
      return newObj;
    }

    
    // For non-payment tables, use the standard mapping
    for (const key in obj) {
      if (key in allfields) {
        if (key == "col_disc") {
          newObj[allfields[key]] = obj["col_disc_select"] == "%" ? obj[key] + "%" : obj[key];
        } else {
          if (key != "col_disc_select") {
            newObj[allfields[key]] = obj[key];
          }
        }
      } else {
        newObj[key] = obj[key];
      }
    }
    const { col_tax, col_disc_select, ...newRow } = newObj;
    return newRow;
  }

  function transformDataRemoveKeys(data, deleteKeys) {
    return data.map(item => {
      const transformedItem = { ...item };
      if (transformedItem.col_qty_select) {
        transformedItem.dQuantity = `${transformedItem.dQuantity}`;
      }
      // Ensure dExpectedQuantity is a string and sExpectedUnitConversion has a default
      if (transformedItem.dExpectedQuantity !== undefined) {
        transformedItem.dExpectedQuantity = `${transformedItem.dExpectedQuantity}`;
      }
      if (transformedItem.hasOwnProperty("sExpectedUnitConversion") && (transformedItem.sExpectedUnitConversion === undefined || transformedItem.sExpectedUnitConversion === null)) {
        transformedItem.sExpectedUnitConversion = transformedItem.sUnitConversion || "";
      }
      deleteKeys.forEach(key => {
        delete transformedItem[key];
      });
      return transformedItem;
    });
  }

  const hydratedPayloadRows = useMemo(() => {
    if (!rows?.length || Object.values(rows[0] || {}).length <= 1) return [];

    const modifiedRows = rows.map(obj => replaceKeys(obj, allFieldNames));
    return transformDataRemoveKeys(
      modifiedRows,
      ["col_qty_select", "col_sExpectedType"]
    );
  }, [rows, allFieldNames]);

  const hydratedSummaryField = useMemo(() => ({
    [data?.component?.sName]: `priceoption:${priceSelect || ""};taxcalculation:${selectedTax || ""};currency:${selectedCurrency || ""};othercostallocation:`
  }), [data?.component?.sName, priceSelect, selectedTax, selectedCurrency]);

  useEffect(() => {
    tabledata(hydratedPayloadRows);
  }, [hydratedPayloadRows, tabledata]);

  useEffect(() => {
    setdefaultTableNameAndModel(data.component);
    setdefaultTableSummaryFeild(preState => ({
      ...preState,
      ...hydratedSummaryField
    }));
  }, [data, hydratedSummaryField, setdefaultTableNameAndModel, setdefaultTableSummaryFeild]);

  useEffect(() => {
    if (!onHydrationStateChange) return;

    const descriptorReady =
      Boolean(data?.component?.sName) &&
      data?.component?.options?.mode === "DEFAULT";
    const expectedRows = Array.isArray(persistedDefaultTable?.tabledetails)
      ? persistedDefaultTable.tabledetails
      : [];
    const configuredColumnIds = [
      ...(data?.fixcolumns || [])
        .filter(item => item?.inputType?.component?.sName)
        .map(item => item?.sColumnID),
      ...(data?.child || [])
        .filter(item => item?.component?.sName)
        .map(item => item?.inputtable?.sColumnID)
    ].filter(Boolean);
    const mappingsReady =
      expectedRows.length === 0 ||
      configuredColumnIds.every(columnId => Boolean(allFieldNames?.[columnId]));
    const rowsReady = hydratedPayloadRows.length === expectedRows.length;
    const mainRecordDetails = parseFreeFormMainrecordDetails(
      freeFormTabbleEditMainrecord?.[data?.component?.sName]
    );
    const pricingEnabled =
      data?.pricingOptions?.menu?.bPriceOptionEnabled === true ||
      data?.pricingOptions?.menu?.bPriceOptionEnabled === "true";
    const storedPriceOption = mainRecordDetails?.priceoption;
    const pricingReady =
      !pricingEnabled ||
      !storedPriceOption ||
      priceSelect === storedPriceOption;
    const currencyReady =
      !data?.component?.currency || Boolean(selectedCurrency);
    const storedTax = mainRecordDetails?.taxcalculation;
    const taxReady =
      !data?.component?.taxcalculation ||
      storedTax == null ||
      String(selectedTax || "") === String(storedTax || "");
    const summaryReady =
      expectedRows.length === 0 ||
      Object.prototype.hasOwnProperty.call(summaryCalculations || {}, "summ_grandtotal");
    const ready = isDefaultTableEditHydrated({
      formAction,
      recordHydrated: isEditRecordHydrated === true,
      descriptorReady,
      optionsLoaded: baseOptionsLoaded,
      mappingsReady,
      rowsReady,
      pricingReady,
      currencyReady,
      taxReady,
      summaryReady
    });

    onHydrationStateChange({
      descriptor: data.component,
      rows: hydratedPayloadRows,
      summaryData: hydratedSummaryData,
      summaryField: hydratedSummaryField,
      ready
    });
  }, [
    allFieldNames,
    baseOptionsLoaded,
    data,
    formAction,
    freeFormTabbleEditMainrecord,
    hydratedPayloadRows,
    hydratedSummaryData,
    hydratedSummaryField,
    isEditRecordHydrated,
    onHydrationStateChange,
    persistedDefaultTable,
    priceSelect,
    selectedCurrency,
    selectedTax,
    summaryCalculations
  ]);

  const validateDefaultTable = () => {
    const columnsWithNumericValidation = [
      ...(data?.fixcolumns || [])
        .filter(col =>
          String(col.bVisible) === "true" &&
          isNumericComponentType(col.inputType?.component?.sType) &&
          col.inputType?.validation
        )
        .map(col => ({
          columnId: col.sColumnID,
          label: col.sHeader || col.sColumnID,
          validation: col.inputType.validation
        })),
      ...(data?.child || [])
        .filter(col =>
          String(col?.inputtable?.bVisible) === "true" &&
          isNumericComponentType(col.component?.sType) &&
          col.validation
        )
        .map(col => ({
          columnId: col.inputtable.sColumnID,
          label: col.inputtable.sHeader || col.inputtable.sColumnID,
          validation: col.validation
        }))
    ];

    const requiredFixColumns = (data?.fixcolumns || []).filter(col =>
      String(col.bVisible) === "true" &&
      col.inputType?.validation?.bRequired == 1
    );

    const requiredChildColumns = (data?.child || []).filter(col =>
      String(col?.inputtable?.bVisible) === "true" &&
      col.validation?.bRequired == 1
    );

    let hasError = false;
    const newRowErrors = {};

    for (const row of rows) {
      const rowId = row.id;

      for (const col of requiredFixColumns) {
        const rawValue = row[col.sColumnID];
        const strVal = String(rawValue ?? "").trim();
        const isEmpty =
          rawValue === undefined ||
          rawValue === null ||
          strVal === "";
        if (isEmpty) {
          const label = col.sHeader || col.sColumnID;
          const msg = col.inputType?.validation?.sErrorMessage || `${label} is required`;
          if (!newRowErrors[rowId]) newRowErrors[rowId] = {};
          newRowErrors[rowId][col.sColumnID] = msg;
          hasError = true;
        }
      }

      for (const col of requiredChildColumns) {
        const colId = col.inputtable?.sColumnID;
        const rawValue = row[colId];
        const strVal = String(rawValue ?? "").trim();
        const isEmpty =
          rawValue === undefined ||
          rawValue === null ||
          strVal === "";
        if (isEmpty) {
          const label = col.inputtable?.sHeader || colId;
          const msg = col.validation?.sErrorMessage || `${label} is required`;
          if (!newRowErrors[rowId]) newRowErrors[rowId] = {};
          newRowErrors[rowId][colId] = msg;
          hasError = true;
        }
      }

      for (const col of columnsWithNumericValidation) {
        if (newRowErrors[rowId]?.[col.columnId]) continue;

        const message = getNumericCellError({
          rawValue: row[col.columnId],
          validation: col.validation,
          label: col.label
        });

        if (!message) continue;

        if (!newRowErrors[rowId]) newRowErrors[rowId] = {};
        newRowErrors[rowId][col.columnId] = message;
        CustomAlert("error", message);
        hasError = true;
      }
    }

    const newSummaryErrors = {};

    if (isZeroTotalNotAllowed()) {
      newSummaryErrors.summ_grandtotal = "Please enter amount";
      hasError = true;
    }

    setSummaryErrors(newSummaryErrors);
    setRowErrors(newRowErrors);
    return hasError;
  };

  useEffect(() => {
    if (setdefaultTableValidateFunction) {
      setdefaultTableValidateFunction(() => validateDefaultTable);
      return () => setdefaultTableValidateFunction(false);
    }
  }, [rows]);
useEffect(() => {
  const withholdingConfig = data?.summaryfields?.sSummaryDetails?.find(
    item => item?.sSummaryID === "summ_withholding"
  );

  const source = withholdingConfig?.withHeldInputType?.data?.sDataSource;

  if (!source) return;

  trackRequest(() =>
    fetch(`${baseURL}${source}`, {
      method: "GET",
      headers: {
        Accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
    })
    .then(res => res.json())
  )
    .then(result => {
      setWithholdingOptions(result?.data?.records || []);
    })
    .catch(error => {
      console.error("Error fetching withholding tax options:", error);
    });
}, [data, token]);
const renderWithholdingAutocomplete = (summaryItem) => {
  const config = summaryItem?.withHeldInputType;
  const dataConfig = config?.data;
  const componentConfig = config?.component;
  const idPrefix = `${data?.component?.sName}-${summaryItem?.sSummaryID}`;

  if (componentConfig?.sType !== "AUTOCOMPLETE") return null;

  const valueField = dataConfig?.sValueField;
  const displayField = dataConfig?.sDisplayField;
  const displayFormat = dataConfig?.sDisplayFormat;

  const selectedOption =
    withholdingOptions?.find(option => option?.[valueField] === withholdingCode) || null;

  const getOptionLabel = (option) => {
    if (!option) return "";

    if (displayFormat === "[%s] %.2f") {
      return `[${option?.sWithholdCode || ""}] ${Number(option?.dPercent || 0).toFixed(2)}`;
    }

    if (displayField?.includes("{sWithholdCode}") && displayField?.includes("{dPercent}")) {
      return `[${option?.sWithholdCode || ""}] ${Number(option?.dPercent || 0).toFixed(2)}`;
    }

    return option?.[valueField] || "";
  };

  return (
    <Autocomplete
      id={`${idPrefix}-code`}
      size={componentConfig?.sProps?.size || "small"}
      fullWidth={componentConfig?.sProps?.fullWidth ?? true}
      options={withholdingOptions || []}
      value={selectedOption}
      getOptionLabel={getOptionLabel}
      onChange={(_, selected) => {
        setWithholdingCode(selected?.[valueField] || "");

        if (selected?.dPercent !== undefined) {
          setWithholdingValue(Number(selected.dPercent).toFixed(2));
          setWithholdingSelect("%");
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant={componentConfig?.options?.textFieldProps?.variant || "outlined"}
          placeholder={componentConfig?.sPlaceHolder || ""}
          helperText={componentConfig?.sHelper || ""}
        />
      )}
    />
  );
};
const showLoading =
  isLoading || requestLoading;

const isPriceOptionEnabled =
  data?.pricingOptions?.menu?.bPriceOptionEnabled === true ||
  data?.pricingOptions?.menu?.bPriceOptionEnabled === "true";

const isTaxOptionEnabled =
  data?.component?.taxcalculation?.bVisible === true ||
  data?.component?.taxcalculation?.bVisible === "true";

const isCurrencyEnabled =
  Boolean(data?.component?.currency);

const isActionsEnabled =
  data?.component?.menu?.bEnabled === true ||
  data?.component?.menu?.bEnabled === "true";


return (
  <Grid item xs={12}>
    <Grid
      container
      alignItems="center"
      sx={{
        width: "100%"
      }}
    >
      {/* INPUTTABLE options toolbar */}
      <Grid item xs={12}>
        <Box
            sx={{
              width: "100%",
              display: "grid",

              /*
              * Fixed toolbar positions:
              *
              * Price Option = 30%
              * Tax          = 30%
              * Currency     = 30%
              * Actions      = 10%
              *
              * Disabled controls leave their slot empty, so the
              * remaining controls never change position.
              */
              gridTemplateColumns: {
                xs: "1fr",
                md: "20% 40% 20% 20%"
              },

              alignItems: "center",
              rowGap: 1,
              mb: 1
            }}
          >
            {/* Price Option: fixed first 30% */}
            <Box
              sx={{
                minWidth: 0,
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                pr: 1
              }}
            >
              {isPriceOptionEnabled && (
                <PriceOption
                  data={data}
                  priceSelect={priceSelect}
                  setPriceSelect={setPriceSelect}
                  hasUserSelectedPriceOption={hasUserSelectedPriceOption}
                  priceOptions={priceOptions}
                  setPriceOptions={setPriceOptions}
                  setDisabledPriceOptionRate={
                    setDisabledPriceOptionRate
                  }
                  formAction={formAction}
                  documentSelectTableData={
                    documentSelectTableData
                  }
                />
              )}
            </Box>

            {/* Tax: fixed second 30% */}
            <Box
              sx={{
                minWidth: 0,
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                px: 1
              }}
            >
              {isTaxOptionEnabled && (
                <TaxOption
                  data={data}
                  selectedTax={selectedTax}
                  setSelectedTax={setSelectedTax}
                />
              )}
            </Box>

            {/* Currency: fixed third 30% */}
            <Box
              sx={{
                minWidth: 0,
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                px: 1
              }}
            >
              {isCurrencyEnabled && (
                <CurrencyOption
                  data={data}
                  selectedCurrency={selectedCurrency}
                  setSelectedCurrency={
                    setSelectedCurrency
                  }
                  currencyOptions={currencyOptions}
                  setCurrencyOptions={
                    setCurrencyOptions
                  }
                  formAction={formAction}
                  documentSelectTableData={
                    documentSelectTableData
                  }
                />
              )}
            </Box>

            {/* Actions: fixed final 10% */}
            <Box
              sx={{
                minWidth: 0,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                pl: 1
              }}
            >
              {isActionsEnabled && (
                <ActionsMenu
                  data={data}
                  clearColumns={clearColumns}
                  resetTable={resetTable}
                  openBulkLoad={openBulkLoad}
                />
              )}
            </Box>
          </Box>
      </Grid>

      <Grid item xs={12}>
        <div
          style={{
            position: "relative",
            width: "100%"
          }}
        >
          {/* blurred content (grid) */}
          <div
            style={{
              ...data?.component?.sParentContainerProps?.style,
              filter: showLoading ? "blur(5px)" : "none",
              transition: "filter 150ms",
            }}
          >     
            <Box
              sx={{
                minHeight: 150,
                ...data?.component?.sParentContainerProps?.style,
                // Hide scrollbar when no rows
                ...(rows?.length === 0 && {
                  '& .MuiDataGrid-virtualScroller': {
                    overflow: 'hidden'
                  }
                }),
              }}
            >
              {/* NOTE: disable built-in loader by passing loading={false} */}
              <DataGridPro
                getRowId={(row) => row.id}
                slots={
                  data?.component?.slotProps &&
                  Object.keys(data?.component?.slotProps).length > 0
                    ? { toolbar: GridToolbar }
                    : {}
                }
                slotProps={data?.component?.slotProps}
                loading={false}           /* <- keep false so MUI overlay doesn't show */
                rows={rows}
                columns={columns}
                columnVisibilityModel={columnVisibilityModel}
                pagination={false}
                localeText={{ noRowsLabel: "No records" }}
                disableColumnMenu
                hideFooter
                {...data?.component?.sProps}
                rowReordering
                onRowOrderChange={handleRowOrderChange}
              />
            </Box>
          </div>
          {/* Show "No records" overlay when rows is empty and not loading */}
          {!showLoading && rows?.length === 0 && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pointerEvents: "none",
                zIndex: 1,
              }}
            >
              <Typography sx={{ fontSize: '0.75rem', color: '#000000' }}>No records</Typography>
            </div>
          )}
          {showLoading && (
            <div
              style={{
                position: "absolute",
                inset: 0,            
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pointerEvents: "none",
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  padding: 16,
                  borderRadius: 8,
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: 12,
                }}
              >
                <CircularProgress />
                <div>Loading...</div>
              </div>
            </div>
          )}
          <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between", width: "100%" }}>       
          <AddRowButton 
            data={data}
            handleAddRow={handleAddRow}
          />
          <Box
            className="overflow-hidden"
            {...data.summaryfields?.sSummarycontainer?.sContainerProps}
            style={{ width: "620px" }}
          >       
            {data?.summaryfields?.sSummaryDetails
              ?.filter((summaryItem) => 
                summaryItem?.bVisible == "true" && 
                summaryItem?.sSummaryID != "summ_grandtotal" &&
                summaryItem?.sSummaryID != "summ_withholding" &&
                summaryItem?.sSummaryID != "summ_tax"
              )?.map((summaryItem) => (
              <Grid container py={1} gap={3} key={summaryItem?.sSummaryID}>
                <Grid item xs={12}>
                  <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography
                      {...summaryItem?.sLabelProps}
                      id={`${summaryItem?.sSummaryID}-label`}
                      sx={{
                        ...(summaryItem?.sLabelProps?.sx?.[0] || {}),
                        flex: 1,
                        textAlign: "left",
                      }}
                    >
                      {summaryItem?.sLabel}
                    </Typography>
                    {summaryItem?.inputType?.component?.sType === "NUMBER" && <Box sx={{flex: 1}}>
                      <SummaryNumber 
                        item={summaryItem} 
                        handleSummaryUpdate={handleSummaryUpdate}
                        id={`${data?.component?.sName}-${summaryItem?.sSummaryID}-value`}
                        formAction={formAction}
                        defaultTableEditData={defaultTableEditData}
                        documentSelectTableData={documentSelectTableData}
                      />
                    </Box>}
                    <Typography 
                      {...summaryItem?.sLabelProps}
                      sx={{
                        ...(summaryItem?.sLabelProps?.sx?.[0] || {}),
                        flex: 1,
                        textAlign: "right",
                      }}
                      id={`${data?.component?.sName}-${summaryItem?.sSummaryID}-amount`}
                    >
                      {formatWithTwoDecimals(toNumber(summaryCalculations?.[summaryItem?.sSummaryID] || 0?.toFixed(2)))}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            ))}

            
            {summaryCalculations && summaryCalculations?.taxCalculations && Object.keys(summaryCalculations?.taxCalculations)?.length > 0 && 
              <>
                {data?.summaryfields?.sSummaryDetails
                  ?.filter((summaryItem) => 
                    summaryItem?.bVisible == "true" &&
                    summaryItem?.sSummaryID == "summ_tax"
                  )?.map((summaryItem) => (
                  <Grid container py={1} gap={3} key={summaryItem?.sSummaryID}>
                    <Grid item xs={12}>
                      <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Typography
                          {...summaryItem?.sLabelProps}
                          id={`${summaryItem?.sSummaryID}-label`}
                          sx={{
                            ...(summaryItem?.sLabelProps?.sx?.[0] || {}),
                            flex: 1,
                            textAlign: "left",
                          }}
                        >
                          {summaryItem?.sLabel}
                        </Typography>
                      </Box>
                    </Grid>
                    {colTaxOptions
                      ?.filter((taxItem) => summaryCalculations?.taxCalculations?.[taxItem?.sTaxCode] !== undefined)
                      ?.map((taxItem) => <Grid item xs={12}>
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                          <Typography
                            {...summaryItem?.sLabelProps}
                            sx={{
                              ...(summaryItem?.sLabelProps?.sx?.[0] || {}),
                              flex: 1,
                              textAlign: "left",
                            }}
                            id={`${data?.component?.sName}-${summaryItem?.sSummaryID}-${taxItem?.sTaxCode}-label`}
                          >
                            {taxItem?.sTaxName}
                          </Typography>
                          <Typography 
                            {...summaryItem?.sLabelProps}
                            sx={{
                              ...(summaryItem?.sLabelProps?.sx?.[0] || {}),
                              flex: 1,
                              textAlign: "center",
                            }}
                            id={`${data?.component?.sName}-${summaryItem?.sSummaryID}-${taxItem?.sTaxCode}-value`}
                          >
                            {formatWithTwoDecimals(toNumber(summaryCalculations?.taxCalculations?.[taxItem?.sTaxCode]?.afterTax || 0?.toFixed(2)))}
                          </Typography>
                          <Typography 
                            {...summaryItem?.sLabelProps}
                            sx={{
                              ...(summaryItem?.sLabelProps?.sx?.[0] || {}),
                              flex: 1,
                              textAlign: "right",
                            }}
                            id={`${data?.component?.sName}-${summaryItem?.sSummaryID}-${taxItem?.sTaxCode}-amount`}
                          > 
                            {formatWithTwoDecimals(toNumber(summaryCalculations?.taxCalculations?.[taxItem?.sTaxCode]?.taxAmount || 0?.toFixed(2)))}
                          </Typography>
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                ))}
              </>
            }

            {data?.summaryfields?.sSummaryDetails
              ?.filter((summaryItem) =>
                summaryItem?.bVisible == "true" &&
                summaryItem?.sSummaryID == "summ_withholding"
              )
              ?.map((summaryItem) => (
                <Grid container py={1} gap={1} key={summaryItem?.sSummaryID}>
                  <Grid item xs={12}>
                    <Typography
                      {...summaryItem?.sLabelProps}
                      id={`${data?.component?.sName}-${summaryItem?.sSummaryID}-label`}
                      sx={{
                        ...(summaryItem?.sLabelProps?.sx?.[0] || {}),
                        textAlign: "left",
                        mb: 1,
                      }}
                    >
                      {summaryItem?.sLabel}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Box display="flex" alignItems="center" justifyContent="space-between" gap={2}>
                      <Box sx={{ display: "flex", gap: 1, flex: 1 }}>
                        <Box sx={{ flex: 1, minWidth: 250 }}>
                          {renderWithholdingAutocomplete(summaryItem)}
                        </Box>

                        <Box sx={{ width: 180 }}>
                          {renderSummaryInputType(summaryItem)}
                        </Box>
                      </Box>

                      <Typography
                        {...summaryItem?.sLabelProps}
                        sx={{
                          ...(summaryItem?.sLabelProps?.sx?.[0] || {}),
                          minWidth: 120,
                          textAlign: "right",
                        }}
                        id={`${data?.component?.sName}-${summaryItem?.sSummaryID}-amount`}
                      >
                        {formatWithTwoDecimals(toNumber(summaryCalculations?.summ_withholding || 0))}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
            ))} 

            {data?.summaryfields?.sSummaryDetails
              ?.filter((summaryItem) => 
                summaryItem?.bVisible == "true" && 
                summaryItem?.sSummaryID == "summ_grandtotal"
              )?.map((summaryItem) => (
              <Grid container py={1} gap={3} key={summaryItem?.sSummaryID}>
                <Grid item xs={12}>
                  <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography
                      {...summaryItem?.sLabelProps}
                      id={`${summaryItem?.sSummaryID}-label`}
                      sx={{
                        ...(summaryItem?.sLabelProps?.sx?.[0] || {}),
                        flex: 1,
                        textAlign: "left",
                      }}
                    >                      
                      {summaryItem?.sLabel} {summaryItem?.sSummaryID == "summ_grandtotal" ? `(${selectedCurrency?.split(":")?.[0] || ""})` : ""}
                    </Typography>
                    <Typography 
                      {...summaryItem?.sLabelProps}
                      sx={{
                        ...(summaryItem?.sLabelProps?.sx?.[0] || {}),
                        flex: 1,
                        textAlign: "right",
                      }}
                      id={`${data?.component?.sName}-${summaryItem?.sSummaryID}-amount`}
                    >
                      {formatWithTwoDecimals(toNumber(summaryCalculations?.[summaryItem?.sSummaryID] || 0?.toFixed(2)))}
                    </Typography>
                  </Box>
                  {summaryErrors?.[summaryItem?.sSummaryID] && (
                    <Typography
                      variant="caption"
                      sx={{
                        color: "error.main",
                        display: "block",
                        textAlign: "right",
                        width: "100%",
                        mt: 0.5
                      }}
                      id={`${data?.component?.sName}-${summaryItem?.sSummaryID}-error`}
                    >
                      {summaryErrors[summaryItem.sSummaryID]}
                    </Typography>
                  )}
                  {(data?.component?.currency?.sDefaultValue !== selectedCurrency?.split(":")?.[0]) && <Box sx={{ marginTop: 1 }}>
                    <Typography
                      component="span"
                      variant="inherit"
                      id={`${data?.component?.sName}-grandtotal-conversion`}
                    >
                      {currencyConversion}
                    </Typography>
                  </Box>}
                </Grid>
              </Grid>
            ))}
          </Box>
        </Box>
        </div>
      </Grid>
    </Grid>

      <Dialog fullWidth maxWidth="lg" open={bulkLoadOpen}>
        <IconButton
          onClick={() => { setBulkLoadOpen(false); setBulkLoadData([]); }}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle>
          {data?.component?.[bulkActionType]?.sSubmenuCaption}
        </DialogTitle>
        <DialogContent>
          {bulkLoadOpen && (
            <SelectAllTransferList
              setBulkLoadData={setBulkLoadData}
              freeForm={rows}
              data={data}
              sDisplayFormat={data?.component?.[bulkActionType]?.sDisplayFormat || data?.component?.bulkLoad?.sDisplayFormat}
              token={token}
              uri={replaceBracketPlaceholders(data?.component?.[bulkActionType]?.sDataSource || "", textValue)}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="contained"
            disabled={BulkLoadData.length === 0}
            onClick={handleBulkLoad}
            id="button-save"
          >
            Save
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={() => { setBulkLoadOpen(false); setBulkLoadData([]); }}
            id="button-close"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default InputTableDefault;
